import {ErrorCode} from '@/services/ErrorsService/ErrorsService.constants';
import {AnalyticsSettingsSwitchType} from '@/services/TrackingService/TrackingService.constants';
import {
  PersonalGameStatisticsItem,
  ProjectGameStatisticsItem,
} from '@/stores/GameStatisticsStore/GameStatisticsStore.types';
import {GameStatusType} from '@/stores/GameStatusStore/GameStatusStore.constants';
import {
  GiftTabType,
  GiftType,
  GiftsIconDefaultType,
  GiftsIconType,
  ResultGiftType,
} from '@/stores/GiftsStore/GiftsStore.constants';
import {GiftStatic} from '@/stores/GiftsStore/GiftsStore.types';
import {
  LeaderBoardStatusType,
  LeagueType,
  bronzeLeagueTopPlayersCount,
  goldLeagueTopPlayersCount,
  silverLeagueTopPlayersCount,
} from '@/stores/LeaderBoardStore/LeaderBoardStore.constants';
import {
  DailyGameOnboardingSteps,
  MainOnboardingFinishSteps,
  MainOnboardingStartSteps,
  MainOnboardingSteps,
  TooltipId,
} from '@/stores/OnboardingStore/OnboardingStore.constants';
import {SettingsType} from '@/stores/SettingsStore/SettingsStore.constants';
import {TaskExecutionRules} from '@/stores/TasksStore/TasksStore.constants';
import {Winner} from '@/stores/WinnersStore/WinnersStore.types';

import {envs} from '@/envs';
import {LocationType} from '@/services/ProjectAuthApi/types';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  AppErrorFullScreen: {
    image: {
      src: {
        png: 'static/invest24/auth_error_kotletka-320-2024-10-29-16-22-27.png 320w, static/invest24/auth_error_kotletka-640-2024-10-29-16-22-27.png 854w',
        avif: 'static/invest24/auth_error_kotletka-320-2024-10-29-16-22-27.avif 320w, static/invest24/auth_error_kotletka-640-2024-10-29-16-22-27.avif 854w',
        webp: 'static/invest24/auth_error_kotletka-320-2024-10-29-16-22-27.webp 320w, static/invest24/auth_error_kotletka-640-2024-10-29-16-22-27.webp 854w',
      },
      alt: 'Котлетка',
    },
  },
  AppErrorGameIsNotAProgress: {
    kotletkaImageBody: {
      png: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.png 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.png 854w',
      avif: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.avif 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.avif 854w',
      webp: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.webp 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.webp 854w',
    },
    kotletkaImageFingers: {
      png: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.png 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.png 854w',
      avif: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.avif 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.avif 854w',
      webp: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.webp 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.webp 854w',
    },
    showBeforeContent: true,
    beforeResults: {
      title: 'Игра закончилась, но это еще не все',
      subtitleMobile:
        'Отправляйтесь на завод, где каждый добытый слиток приближает вас к победе. Как найти игру в приложении Т‑Инвестиций: «Чаты» → чат «Завод',
      subtitleDesktop:
        'Отправляйтесь на завод, где каждый добытый слиток приближает вас к победе. Как найти игру в приложении Т‑Инвестиций: «Чаты» → чат «Завод',
      // cta: {
      //   text: 'Подробнее',
      //   href: {
      //     mobileLink: 'https://l.tbank.ru/zavod',
      //     mobileLinkIos: 'https://l.tbank.ru/zavod_ios',
      //     mbAppDeeplink: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/ShowCustomStory?storyId=44329',
      //     investAppDeeplink: 'tcsgames://action/browser?link=tinkoffbank://Main/ShowCustomStory?storyId=44329',
      //   },
      // },
    },
    afterResults: {
      title: 'Игра закончилась',
      subtitleMobile:
        'Денежная Котлетка еще вернется с новым приключением. А пока вы можете посмотреть другие игры Т‑Банка в приложении: «Город» → «Мини‑игры»',
      subtitleDesktop:
        'Денежная Котлетка еще вернется с новым приключением. А пока вы можете посмотреть другие игры Т‑Банка в приложении: «Город» → «Мини‑игры»',
      cta: {
        text: 'Сыграть в другую',
        href: {
          mobileLink: 'https://l.tbank.ru/gorod_sps',
          mobileLinkIos: 'https://l.tbank.ru/gorod_sps',
          mbAppDeeplink: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Entertainment',
          investAppDeeplink: 'tcsgames://action/browser?link=tinkoffbank://Main/Entertainment',
        },
      },
    },
  },
  AuthPageUser: {
    title: 'Вход для клиентов Т‑Банка',
  },
  ErrorCodeMessage: {
    errorCodeTitleTemplate: 'Ошибка %errorCodeTitle%.',
    identificatorText: 'Идентификатор:',
    timestampText: 'Время: ',
    defaultErrorCodeTitle: ErrorCode.UnknownError,
    defaultErrorDescription: 'Что-то пошло не так',
  },
  ClosedModal: {
    kotletkaImageBody: {
      png: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.png 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.png 854w',
      avif: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.avif 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.avif 854w',
      webp: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.webp 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.webp 854w',
    },
    kotletkaImageFingers: {
      png: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.png 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.png 854w',
      avif: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.avif 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.avif 854w',
      webp: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.webp 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.webp 854w',
    },
    title: 'Проект завершен',
    description: 'Это демо версия игры. Вы можете кликать, разбивать метеориты и покупать улучшения. Прогресс не сохраняем.',
    button: 'Играть',
  },
  ErrorDefault: {
    title: 'Что-то пошло не так',
    text: 'Попробуйте перезагрузить страницу или вернуться позже',
  },
  Footer: {
    links: [
      {
        text: 'Условия акции',
        link: {
          smallVersion: 'https://cdn.tbank.ru/static/documents/promo-space-investors-m.pdf',
          bigVersion: 'https://cdn.tbank.ru/static/documents/promo-space-investors.pdf',
        },
      },
      {
        text: 'Тарифы по карте Black',
        link: {
          bigVersion: 'https://cdn.tbank.ru/static/documents/debit-tariffs-tps_3_0.pdf',
        },
      },
      {
        text: 'Программа лояльности Black',
        link: {
          bigVersion: 'https://cdn.tbank.ru/static/documents/loyalty-program-black.pdf',
        },
      },
    ],
    title: [
      'Спейс‑инвесторс — космические инвесторы, новая игра от Т‑Банка. Тапать — от англ. to tap — касаться, нажимать.',
      `© 2006–${new Date().getFullYear()}, АО «ТБанк», официальный сайт, универсальная лицензия ЦБ РФ № 2673`,
    ],
  },
  BottomMenuActive: {
    tasksName: 'Задания',
    improvementsName: 'Улучшения',
  },
  BottomMenuBeforeResults: {
    resultsName: 'Розыгрыш',
    resultsDate: '17.01',
    statisticsName: 'Статистика',
    tooltipText: 'Скоро тут будет ваша игровая статистика',
  },
  BottomMenuAfterResults: {
    winnersName: 'Победители',
    statisticsName: 'Статистика',
  },
  ClickerRadar: {
    radarLocatorImage: {
      src: {
        png: 'static/invest24/radar-scanner-161-2024-10-01-12-08-14.png 320w',
        avif: 'static/invest24/radar-scanner-161-2024-10-01-12-08-14.avif 320w',
        webp: 'static/invest24/radar-scanner-161-2024-10-01-12-08-14.webp 320w',
      },
      alt: 'Радар',
    },
    inactiveRadarLocatorImage: {
      src: {
        png: 'static/invest24/radar-scanner-innactive-161-2024-10-01-15-01-29.png 320w',
        avif: 'static/invest24/radar-scanner-innactive-161-2024-10-01-15-01-29.avif 320w',
        webp: 'static/invest24/radar-scanner-innactive-161-2024-10-01-15-01-29.webp 320w',
      },
      alt: 'Радар',
    },
  },
  CipherDailyPreloader: {
    text: 'Устанавливаем зашифрованный сигнал со спутником связи',
  },
  ClickerGamePoints: {
    perHoursText: 'Доход в час: %points%',
  },
  CipherResult: {
    title: 'Тикер отгадан!',
    text: 'Еще больше знаний об акциях вы можете получить в соцсети «Пульс»',
    rewardText: 'Награда',
    buttonText: 'Забрать награду',
  },
  CipherDailyRadar: {
    radarSpriteSheet: 'https://ps-static.cdn-tinkoff.ru/static/invest24/daily-game_radar-2024-09-30-09-20-53.png',
    starSpriteSheet: 'https://ps-static.cdn-tinkoff.ru/static/invest24/daily-game_star-2024-09-30-10-50-44.png',
  },
  CipherDailyHeader: {
    title: 'Отгадайте биржевой тикер %tip%%tip%, чтобы найти тайник с кристаллами',
    titleMocks: 'Игроки отгадывали ежедневный тикер %tip%%tip%, чтобы заработать больше кристаллов. Попробуйте угадать и вы',
    tip: 'Узнать подсказку',
  },
  CipherDailyModalCopyLink: {
    title: 'Если кнопка не работает',
    text: 'Скопируйте ссылку и вставьте ее в браузер на вашем устройстве',
  },
  TaskModalCopyLink: {
    title: 'Ох, кнопка не работает',
    text: 'Скопируйте ссылку задания и вставьте ее в браузере устройства',
  },
  CopyButton: {
    buttonText: 'Скопировать ссылку',
    buttonTextCopied: 'Скопировано',
  },
  CipherDailyModalTip: {
    title: 'Что такое тикер?',
    text: 'Тикер — это короткое имя акции на бирже. Как позывной у самолета, только для ценных бумаг. Инвесторы используют тикеры, чтобы быстро находить акции в торговых системах %br%%br%%br%%br% Например:%br%%br%%br%%br%• Лукойл — LKOH%br%%br%• Газпром — GAZP%br%%br%• ВК — VKCO',
  },
  CipherDailyMockTip: {
    title: 'Подсказка',
  },
  ClickerPageTooltips: {
    rechargeWithCharges: 'Используйте батарейки, чтобы восполнить энергию',
    rechargeWithTasks: 'Выполняйте задания, чтобы восполнить энергию',
    radarMocksText: 'Чтобы посмотреть другой тикер, перезайдите в проект',
  },
  CipherDailyBottomBackground: {
    backgroundImage: {
      src: {
        png: 'static/invest24/cipher-daily-background-320-2024-08-23-09-38-14.png 320w, static/invest24/cipher-daily-background-780-2024-08-23-09-38-14.png 854w',
        avif: 'static/invest24/cipher-daily-background-320-2024-08-23-09-38-14.avif 320w, static/invest24/cipher-daily-background-780-2024-08-23-09-38-14.avif 854w',
        webp: 'static/invest24/cipher-daily-background-320-2024-08-23-09-38-14.webp 320w, static/invest24/cipher-daily-background-780-2024-08-23-09-38-14.webp 854w',
      },
      alt: 'Фон',
    },
    kotletkaImage: {
      src: {
        png: 'static/invest24/cipher-daily-kotletka-320-2024-08-23-09-38-43.png 320w, static/invest24/cipher-daily-kotletka-562-2024-08-23-09-38-43.png 854w',
        avif: 'static/invest24/cipher-daily-kotletka-320-2024-08-23-09-38-43.avif 320w, static/invest24/cipher-daily-kotletka-562-2024-08-23-09-38-43.avif 854w',
        webp: 'static/invest24/cipher-daily-kotletka-320-2024-08-23-09-38-43.webp 320w, static/invest24/cipher-daily-kotletka-562-2024-08-23-09-38-43.webp 854w',
      },
      alt: 'Котлетка',
    },
  },
  CipherDailyResult: {
    title: 'Вы выиграли!',
    kotletkaImage: {
      src: {
        png: 'static/invest24/cipher-daily-result-kotletka-320-2024-08-23-09-39-47.png 320w, static/invest24/cipher-daily-result-kotletka-640-2024-08-23-09-39-47.png 854w',
        avif: 'static/invest24/cipher-daily-result-kotletka-320-2024-08-23-09-39-47.avif 320w, static/invest24/cipher-daily-result-kotletka-640-2024-08-23-09-39-47.avif 854w',
        webp: 'static/invest24/cipher-daily-result-kotletka-320-2024-08-23-09-39-47.webp 320w, static/invest24/cipher-daily-result-kotletka-640-2024-08-23-09-39-47.webp 854w',
      },
      alt: 'Котлетка',
    },
    gridImage: {
      src: {
        png: 'static/invest24/cipher-daily-result-grid-320-2024-08-23-09-39-09.png 320w, static/invest24/cipher-daily-result-grid-780-2024-08-23-09-39-09.png 854w',
        avif: 'static/invest24/cipher-daily-result-grid-320-2024-08-23-09-39-09.avif 320w, static/invest24/cipher-daily-result-grid-780-2024-08-23-09-39-09.avif 854w',
        webp: 'static/invest24/cipher-daily-result-grid-320-2024-08-23-09-39-09.webp 320w, static/invest24/cipher-daily-result-grid-780-2024-08-23-09-39-09.webp 854w',
      },
      alt: 'Сетка',
    },
  },
  CrystalIcon: {
    src: {
      png: 'static/invest24/crystal-96-2024-09-02-10-05-36.png 320w',
      avif: 'static/invest24/crystal-96-2024-09-02-10-05-36.avif 320w',
      webp: 'static/invest24/crystal-96-2024-09-02-10-05-36.webp 320w',
    },
    alt: 'Кристал',
  },
  InvitePage: {
    btnText: 'Присоединиться',
  },
  ClickerGameEnergyModal: {
    title: 'Энергия',
    commonText: 'Игроки выполняли задания, чтобы получить заряды. Или дожидались полного восстановления через %time%',
    fullBatteryText: 'Игроки выполняли задания, чтобы получить заряды.',
    rechargeWithClick: 'Нажмите на капсулу, чтобы зарядить корабль. Или дождитесь полного восстановления через %time%',
    chargeCountText: '%beforeIconText% %FullBatteryIcon%%FullBatteryIcon% %number% %chargeText%',
    emptyChargeCountText: '%EmptyBatteryIcon%%EmptyBatteryIcon% 0 зарядов',
    beforeIconTextVars: ['Остался', 'Осталось', 'Осталось'],
    preventClickText: 'Батарейка достаточно заряжена',
  },
  NavigationClickerBackButton: {
    closeBtnText: 'К игре',
  },
  NavigationClickerModal: {
    closeBtnText: 'Назад',
  },
  ClickerContainer: {
    locations: {
      [LocationType.Location1]: 'linear-gradient(180deg, #0F0115 0%, #16021E 35.15%, #2D0C63 100%)',
      [LocationType.Location2]: 'linear-gradient(180deg, #0F0115 0%, #16021E 35.15%, #5D0C63 100%)',
      [LocationType.Location3]: 'linear-gradient(180deg, #0F0115 0%, #16021E 35.15%, #0C5963 100%)',
      [LocationType.Location4]: 'linear-gradient(180deg, #0F0115 0%, #16021E 35.15%, #095829 100%)',
    },
  },
  TasksPage: {
    description: 'Выполняйте задания, чтобы быстрее восстанавливать энергию и зарабатывать больше кристаллов',
    descriptionMockStatus: 'Игроки выполняли задания, чтобы увеличить мультитап и заработать дополнительные батарейки',
  },
  TasksHeader: {
    title: 'Задания',
  },
  UserGameResources: {
    multiTapText: '%multiTap% за тап',
  },
  TasksList: {
    tasksListDoneTitle: 'Выполненные',
    renderAvailableTaskDateText: 'Новые задания появятся %date%',
    allTasksDoneText: 'Вы выполнили все задания, вот это да!',
  },
  TaskCard: {
    executionRulesText: {
      [TaskExecutionRules.NoPulseProfile]: 'Зарегистрируйтесь в «Пульсе», чтобы разблокировать задание',
      [TaskExecutionRules.OverEighteen]: 'Задание доступно только совершеннолетним',
      [TaskExecutionRules.HasInvestBox]: 'Откройте Инвесткопилку, чтобы разблокировать задание',
      [TaskExecutionRules.HasBrokerAccount]: 'Откройте брокерский счет, чтобы разблокировать задание',
      [TaskExecutionRules.HasBlackCard]: 'Оформите карту Black, чтобы разблокировать задание',
      [TaskExecutionRules.HasPulseProfile]: 'Зарегистрируйтесь в «Пульсе», чтобы разблокировать задание',
      [TaskExecutionRules.InvestRiskProfileIsDefined]: 'Заполнен риск-профиль',
      [TaskExecutionRules.InvestRiskProfileIsNotDefined]: 'Не заполнен риск-профиль',
    },
    delayText: 'Может быть задержка при проверке задания',
    expiredText: 'Время на задание истекло',
  },
  TaskReward: {
    multiTapText: '×%multiTap%',
  },
  TaskActions: {
    claimRewardButtonText: 'Получить награду',
    shareDefaultText: 'Скопировать ссылку',
    copySuccessText: 'Скопировано',
  },
  HeaderLeaderBoard: {
    tooltipText: 'Осталось до пересчета лиг',
  },
  LeaderBoardMocksHeader: {
    text: 'Золотая лига',
  },
  HeaderLeaderBoardGameFinished: {
    text: 'Рейтинг',
  },
  HeaderGameStatistics: {
    text: 'Статистика',
  },
  LeaderBoardIcons: {
    [LeagueType.Bronze]: {
      header: {
        png: 'static/invest24/bronzeHeader-48-2024-10-01-07-12-40.png 320w',
        avif: 'static/invest24/bronzeHeader-48-2024-10-01-07-12-40.avif 320w',
        webp: 'static/invest24/bronzeHeader-48-2024-10-01-07-12-40.webp 320w',
      },
      active: {
        png: 'static/invest24/bronseActive-140-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/bronseActive-140-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/bronseActive-140-2024-10-01-07-12-39.webp 320w',
      },
      default: {
        png: 'static/invest24/bronseDefault-80-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/bronseDefault-80-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/bronseDefault-80-2024-10-01-07-12-39.webp 320w',
      },
      blocked: {
        png: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.webp 320w',
      },
    },
    [LeagueType.Silver]: {
      header: {
        png: 'static/invest24/silverHeader-48-2024-10-01-07-12-40.png 320w',
        avif: 'static/invest24/silverHeader-48-2024-10-01-07-12-40.avif 320w',
        webp: 'static/invest24/silverHeader-48-2024-10-01-07-12-40.webp 320w',
      },
      active: {
        png: 'static/invest24/silverActive-140-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/silverActive-140-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/silverActive-140-2024-10-01-07-12-39.webp 320w',
      },
      default: {
        png: 'static/invest24/silverDefault-80-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/silverDefault-80-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/silverDefault-80-2024-10-01-07-12-39.webp 320w',
      },
      blocked: {
        png: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.webp 320w',
      },
    },
    [LeagueType.Gold]: {
      header: {
        png: 'static/invest24/goldHeader-51-2024-10-01-07-12-40.png 320w',
        avif: 'static/invest24/goldHeader-51-2024-10-01-07-12-40.avif 320w',
        webp: 'static/invest24/goldHeader-51-2024-10-01-07-12-40.webp 320w',
      },
      active: {
        png: 'static/invest24/goldActive-140-2024-10-01-07-12-40.png 320w',
        avif: 'static/invest24/goldActive-140-2024-10-01-07-12-40.avif 320w',
        webp: 'static/invest24/goldActive-140-2024-10-01-07-12-40.webp 320w',
      },
      default: {
        png: 'static/invest24/goldDefault-80-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/goldDefault-80-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/goldDefault-80-2024-10-01-07-12-39.webp 320w',
      },
      blocked: {
        png: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/blockedLeagueDefault-140-2024-10-01-07-12-39.webp 320w',
      },
    },
    [LeagueType.Diamond]: {
      header: {
        png: 'static/invest24/diamondHeader-48-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/diamondHeader-48-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/diamondHeader-48-2024-10-01-07-12-39.webp 320w',
      },
      active: {
        png: 'static/invest24/diamondActive-140-2024-10-01-07-12-40.png 320w',
        avif: 'static/invest24/diamondActive-140-2024-10-01-07-12-40.avif 320w',
        webp: 'static/invest24/diamondActive-140-2024-10-01-07-12-40.webp 320w',
      },
      default: {
        png: 'static/invest24/diamondDefault-80-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/diamondDefault-80-2024-10-01-07-12-39.avif 320w',
        webp: 'static/invest24/diamondDefault-80-2024-10-01-07-12-39.webp 320w',
      },
      blocked: {
        png: 'static/invest24/blockedLeagueDiamond-140-2024-10-01-07-12-39.png 320w',
        avif: 'static/invest24/blockedLeagueDiamond-140-2024-10-01-07-12-39.avif 854w',
        webp: 'static/invest24/blockedLeagueDiamond-140-2024-10-01-07-12-39.webp 320w',
      },
    },
  },
  LeaguesTabs: {
    tabs: [LeagueType.Bronze, LeagueType.Silver, LeagueType.Gold, LeagueType.Diamond],
  },
  LeaderBoardTop: {
    title: {
      [LeagueType.Bronze]: 'Бронзовая лига',
      [LeagueType.Silver]: 'Серебряная лига',
      [LeagueType.Gold]: 'Золотая лига',
      [LeagueType.Diamond]: 'Алмазная лига',
    },
    modal: {
      title: 'О лигах',
      description: [
        'Лиги — это система рейтингов в игре «Спейс‑Инвесторс». Чем %u%выше доход кристаллов в час%u%, тем выше место в рейтинге.',
        'Всего 4 лиги: Бронзовая, Серебряная, Золотая и Алмазная. В каждой лиге игроки делятся на группы от 30 до 50 человек.',
        '%u%Каждую неделю в ночь с воскресенья на понедельник в 00:00 мск%u% мы подсчитываем результаты и определяем лучших. Топ игроков в группе получают призы и переходят в новую лигу. 5 игроков с конца рейтинга возвращаются в лигу на уровень ниже. Игроки в середине рейтинга остаются в той же лиге.',
        'Чем выше лига, тем ценнее призы.',
      ],
    },
  },
  LeaderBoardList: {
    columnName: 'Имя',
    columnIncomePerHour: 'Доход в час',
    zoneTopDefault: 'Места на повышение',
    zoneTopDefaultMocks: 'Топ рейтинга',
    zoneTopWithGifts: 'Призовые места',
    zoneMiddleDefault: 'Места без изменений',
    zoneMiddleWithoutGifts: 'Места без подарков',
    zoneBottom: 'Места на понижение',
    redirectButtonText: 'Мои призы',
  },
  LeaderBoardGiftCard: {
    content: {
      [LeagueType.Bronze]: null,
      [LeagueType.Silver]: {
        title: `Окажитесь в топ-${bronzeLeagueTopPlayersCount} игроков Бронзовой лиги`,
        description: 'Чтобы перейти в Серебряную лигу, получить призы и билеты на участие в главном розыгрыше призов',
      },
      [LeagueType.Gold]: {
        title: `Окажитесь в топ-${silverLeagueTopPlayersCount} игроков Серебряной лиги`,
        description: 'Чтобы перейти в Золотую лигу, получить призы и билеты на участие в главном розыгрыше призов',
      },
      [LeagueType.Diamond]: {
        title: `Окажитесь в топ-${goldLeagueTopPlayersCount} игроков Золотой лиги`,
        description: 'Чтобы перейти в Алмазную лигу, получить призы и билеты на участие в главном розыгрыше призов',
      },
    },
    image: {
      png: 'static/invest24/leaderBoadrGift-320-2024-11-21-13-16-38.png 320w, static/invest24/leaderBoadrGift-640-2024-11-21-13-16-38.png 854w',
      avif: 'static/invest24/leaderBoadrGift-320-2024-11-21-13-16-38.avif 320w, static/invest24/leaderBoadrGift-640-2024-11-21-13-16-38.avif 854w',
      webp: 'static/invest24/leaderBoadrGift-320-2024-11-21-13-16-38.webp 320w, static/invest24/leaderBoadrGift-640-2024-11-21-13-16-38.webp 854w',
    },
  },
  LeaderBoardNotActiveCard: {
    [LeaderBoardStatusType.New]: {
      title: 'Откройте лиги — получайте призы и соревнуйтесь с другими игроками',
      description: 'Инвестируйте в первое улучшение и начните соревнование за призы',
      buttonText: 'Купить улучшение',
    },
    [LeaderBoardStatusType.Pending]: {
      title: 'Поиск игроков…',
      description: 'Корзина формируется, подождите немного',
      buttonText: 'Обновить',
    },
  },
  LeaderBoardTimerPlaceholder: {
    title: 'На паузе',
    subtitle: 'Подводим итоги последней недели с 00:00 по мск. Это займет около двух часов. Приходите позже',
  },
  LeagueRecalculation: {
    animateImageUrl: `${envs.APP_STATIC_BASE_URL}/static/invest24/kotletka_sleepy_vertical-2024-10-18-13-29-33.png`,
    title: 'На паузе',
    description: 'Подводим итоги последней недели с 00:00 по мск. Это займет около двух часов. Приходите позже',
  },
  ImprovementsHeader: {
    description: 'Покупайте и прокачивайте улучшения, чтобы добывать больше кристаллов',
    mocksDescription: 'С помощью улучшений игроки добывали больше кристаллов',
  },
  ImprovementCard: {
    incomeText: '%value% в час',
  },
  ImprovementCardCost: {
    levelText: '%level% ур.',
  },
  ImprovementModal: {
    buttonCost: 'Стоимость: %cost%%CrystalIcon%%CrystalIcon%',
    buttonBuy: 'Купить за %cost%%CrystalIcon%%CrystalIcon%',
    buttonUpgrade: 'Улучшить за %cost%%CrystalIcon%%CrystalIcon%',
    buttonUpgradeLockedByFrozenUntilText: 'Улучшить через %timer% за %cost%%CrystalIcon%%CrystalIcon%',
    buttonAntiFrozenUntilText: 'Улучшить сейчас за %cost%%CrystalIcon%%CrystalIcon%',
    lockByIncomeText: 'Чтобы открыть, нужен доход %value% в час',
    lockByCostText: 'Не хватает %cost%%CrystalIcon%%CrystalIcon%',
  },
  ImprovementDetailIncome: {
    levelText: 'Уровень',
    incomeText: 'Прибыль в час',
  },
  FaqPage: {
    title: 'ОТВЕТЫ НА ВОПРОСЫ',
    questions: [
      {
        question: 'Как играть?',
        answer:
          '%ul%%li%Ваша цель в игре — заработать больше пассивного дохода, чем другие участники%li%%li%Все начинается с простого действия: нажимайте на денежную Котлетку и получайте кристаллы%li%%li%Разбивайте пролетающие астероиды, чтобы заработать еще больше кристалликов%li%%li%На заработанные кристаллы покупайте улучшения — они помогут вам увеличивать пассивный доход%li%%li%Чем эффективнее вы инвестируете в улучшения, тем выше поднимаетесь в рейтинге игроков и увеличиваете свои шансы на главные призы%li%%ul%',
      },
      {
        question: 'Как получить призы?',
        answer:
          'Следите за рейтингом и старайтесь занимать верхние позиции в своей лиге. Чем выше вы поднимаетесь в рейтинге, тем больше шансов перейти в следующую лигу и получить более ценные призы.',
      },
      {
        question: 'Как получить билеты на розыгрыш?',
        answer:
          'Переходите в новые лиги и вместе с призами получайте билеты на участие в розыгрыше. Чем больше билетов соберете, тем выше будет шанс выиграть.',
      },
      {
        question: 'Как найти игру в приложении Т‑Банка?',
        answer:
          '%ul%' +
          '%li%В разделе Город → Мини‑игры%li%' +
          '%ul%' +
          '%FindAppImage%%FindAppImage%' +
          '%ul%' +
          '%li%В мобильном банке в поиске введите: «Спейс-Инвесторс»%li%' +
          '%li%В разделе «Город» → «Все сервисы» → найдите «Спейс-Инвесторс»%li%' +
          '%ul%' +
          '%FindAppButton%%FindAppButton%',
        onlyWeb: true,
      },
      {
        question: 'Как установить приложения Т‑Банка и Т‑Инвестиций?',
        answer: 'Установите приложение по %link%href=https://l.tbank.ru/apps_ask;text=инструкции%link%',
      },
      {
        question: 'Когда будет розыгрыш?',
        answer: 'Розыгрыш пройдет 17 января 2025 года. Результаты опубликуем на главной странице с игрой.',
      },
      {
        question: 'Не получается зайти в игру. Что делать?',
        answer:
          'Напишите в чат поддержки, мы поможем. Будет здорово, если вы сделаете скриншот с экраном ошибки и укажете свою версию приложения — так специалисты смогут быстрее разобраться с проблемой.',
      },
      {
        question: 'Что можно выиграть в главном розыгрыше?',
        answer:
          'Среди всех обладателей билетиков на розыгрыш мы разыграем:%ul%%li%1 500 000 ₽ — денежный фонд разделят 100 игроков, каждый получит по 15 000 ₽.%li%%li%Портфель акций — 65 победителей получат портфели ценных бумаг от Т‑Инвестиций стоимостью до 15 000 ₽.%li%%li%Кэшбэк до 100% в T-Shop — еще 65 победителей смогут выгодно закупиться в магазине мерча Т‑Банка.%li%%ul%',
      },
      {
        question: 'Как узнать, сколько у меня билетов на розыгрыш?',
        answer: 'Загляните в раздел с призами.',
      },
    ],
  },
  InviteIntro: {
    title: 'Натапайте призы и кэшбэк',
    background: {
      image: 'static/invest24/inviteIntroBackground-2024-09-13-12-18-52.jpg',
      alt: 'Фон',
    },
  },
  InviteCta: {
    text: 'Играть',
  },
  MainCta: {
    text: 'Играть',
  },
  MainFeatures: {
    title: 'Как играть?',
    rules: [
      {
        image: {
          png: 'static/invest24/inviteRule1-756-2024-09-13-15-40-13.png',
          avif: 'static/invest24/inviteRule1-756-2024-09-13-15-40-13.avif',
          webp: 'static/invest24/inviteRule1-756-2024-09-13-15-40-13.webp',
        },
        title: 'Добывайте кристаллы',
        subtitle: 'Нажимайте на денежную Котлетку, чтобы зарабатывать кристаллы',
      },
      {
        image: {
          png: 'static/invest24/inviteRule2-756-2024-09-13-15-44-34.png',
          avif: 'static/invest24/inviteRule2-756-2024-09-13-15-44-34.avif',
          webp: 'static/invest24/inviteRule2-756-2024-09-13-15-44-34.webp',
        },
        title: 'Увеличивайте доход',
        subtitle: 'Инвестируйте кристаллы в пассивный доход — чем он больше, тем выше ваш игровой рейтинг',
      },
      {
        image: {
          png: 'static/invest24/inviteRule3-756-2024-10-01-09-03-14.png',
          avif: 'static/invest24/inviteRule3-756-2024-10-01-09-03-14.avif',
          webp: 'static/invest24/inviteRule3-756-2024-10-01-09-03-14.webp',
        },
        title: 'Станьте лидером',
        subtitle: 'Соревнуйтесь с другими игроками в лигах, чтобы получить призы и шанс участвовать в розыгрыше',
      },
    ],
  },
  MainGifts: {
    title: 'Участвуйте в розыгрыше призов',
    bgImages: {
      mobile: 'static/invest24/giftBgMobile-2024-09-16-10-43-26.jpg',
      desktop: 'static/invest24/giftBgDesktop-2024-09-16-10-43-43.jpg',
      alt: 'Фон',
    },
    gifts: [
      {
        image: {
          png: 'static/invest24/investGift1-320-2024-10-30-15-21-43.png 320w, static/invest24/investGift1-520-2024-10-30-15-21-43.png 854w',
          avif: 'static/invest24/investGift1-320-2024-10-30-15-21-43.avif 320w, static/invest24/investGift1-520-2024-10-30-15-21-43.avif 854w',
          webp: 'static/invest24/investGift1-320-2024-10-30-15-21-43.webp 320w, static/invest24/investGift1-520-2024-10-30-15-21-43.webp 854w',
        },
        title: '1 500 000 ₽',
        subtitle: 'Денежный фонд разделят 100 игроков — каждый получит по 15 000 ₽',
      },
      {
        image: {
          png: 'static/invest24/investGift2-320-2024-10-30-15-26-41.png 320w, static/invest24/investGift2-520-2024-10-30-15-26-41.png 854w',
          avif: 'static/invest24/investGift2-320-2024-10-30-15-26-41.avif 320w, static/invest24/investGift2-520-2024-10-30-15-26-41.avif 854w',
          webp: 'static/invest24/investGift2-320-2024-10-30-15-26-41.webp 320w, static/invest24/investGift2-520-2024-10-30-15-26-41.webp 854w',
        },
        title: 'Портфель акций',
        subtitle: '65 победителей получат портфели ценных бумаг от Т‑Инвестиций стоимостью до 15 000 ₽',
      },
      {
        image: {
          png: 'static/invest24/investGift3-320-2024-10-30-15-26-41.png 320w, static/invest24/investGift3-520-2024-10-30-15-26-41.png 854w',
          avif: 'static/invest24/investGift3-320-2024-10-30-15-26-41.avif 320w, static/invest24/investGift3-520-2024-10-30-15-26-41.avif 854w',
          webp: 'static/invest24/investGift3-320-2024-10-30-15-26-41.webp 320w, static/invest24/investGift3-520-2024-10-30-15-26-41.webp 854w',
        },
        title: 'Кэшбэк до 100% в T-Shop',
        subtitle: 'Другие 65 победителей смогут выгодно закупиться в магазине мерча Т‑Банка',
      },
      {
        image: {
          png: 'static/invest24/investGift4-320-2024-10-30-15-21-14.png 320w, static/invest24/investGift4-520-2024-10-30-15-21-14.png 854w',
          avif: 'static/invest24/investGift4-320-2024-10-30-15-21-14.avif 320w, static/invest24/investGift4-520-2024-10-30-15-21-14.avif 854w',
          webp: 'static/invest24/investGift4-320-2024-10-30-15-21-14.webp 320w, static/invest24/investGift4-520-2024-10-30-15-21-14.webp 854w',
        },
        title: 'Гарантированные призы',
        subtitle: 'Каждые 7 дней Т‑Банк и наши партнеры раздают приятные бонусы',
      },
    ],
  },
  MainFaq: {
    title: 'Ответы на вопросы',
  },
  MainForm: {
    title: 'Оформите карту Black',
    benefits: [
      'Заполните онлайн‑заявку — посещать банк не нужно',
      'Пользуйтесь банком в личном кабинете на tbank.ru',
      'Пополняйте карту в личном кабинете с карт других банков без комиссии',
    ],
    benefitIcon: {
      png: 'static/invest24/benifit_icon-52-2024-10-31-12-37-08.png 320w',
      avif: 'static/invest24/benifit_icon-52-2024-10-31-12-37-08.avif 854w',
      webp: 'static/invest24/benifit_icon-52-2024-10-31-12-37-08.webp 320w',
    },
  },
  DailyRewardModal: {
    title: 'Ежедневные награды',
    btn: 'Получить',
  },
  DailyRewardsList: {
    giftTitle: 'Секретный приз',
  },
  Ticket: {
    bgImage: {
      srcDefault: {
        png: 'static/invest24/bgTicket-260-2024-10-08-16-54-17.png 320w',
        avif: 'static/invest24/bgTicket-260-2024-10-08-16-54-17.avif 854w',
        webp: 'static/invest24/bgTicket-260-2024-10-08-16-54-17.webp 320w',
      },
      srcWinner: {
        png: 'static/invest24/bgTicketWinner-260-2024-12-18-09-12-08.png 320w',
        avif: 'static/invest24/bgTicketWinner-260-2024-12-18-09-12-08.avif 854w',
        webp: 'static/invest24/bgTicketWinner-260-2024-12-18-09-12-08.webp 320w',
      },
      alt: 'Билет',
    },
    numberText: '№%number%',
  },
  GiftsHeader: {
    title: 'Призы',
  },
  GiftsTabs: {
    giftTab: 'Можно выиграть',
    userGiftTab: 'Уже у вас',
  },
  GiftsList: {
    gifts: [
      {
        type: GiftType.Static,
        title: 'Акции в Т‑Инвестициях',
        iconType: GiftsIconType.TInvest,
      },
      {
        type: GiftType.Static,
        title: '2 месяца с подпиской Pro в Т‑Банке',
        iconType: GiftsIconType.TPro,
      },
      {
        type: GiftType.Static,
        title: 'Яндекс Плюс: до 60 дней бесплатно',
        iconType: GiftsIconType.YandexPlus,
      },
      {
        type: GiftType.Static,
        title: 'Кэшбэк 15% за покупку в Шопинге',
        iconType: GiftsIconType.TShopping,
      },
      {
        type: GiftType.Static,
        title: 'Скидка 1000 ₽ на первую поездку в Делимобиль',
        iconType: GiftsIconType.Delimobil,
      },
      {
        type: GiftType.Static,
        title: 'Скидка 50% на все виды годовых подписок Яндекс 360',
        iconType: GiftsIconType.Yandex360,
      },
    ] as GiftStatic[],
  },
  GiftTicketCard: {
    [GiftTabType.Gifts]: {
      title: 'Участвуйте в розыгрыше 1 500 000 ₽ и других призов',
      descriptionTitle: 'Подробнее',
      description:
        '%ul%' +
        '%li%%bold%1 500 000 ₽%bold% — денежный фонд разделят 100 игроков. Каждый получит по 15 000 ₽%li%' +
        '%li%%bold%Портфель акций%bold% — 65 победителей получат портфели активов от Т‑Инвестиций стоимостью до 15 000 ₽%li%' +
        '%li%%bold%Кэшбэк до 100% в T-Shop%bold% — 65 победителей смогут выгодно закупиться в магазине мерча Т‑Банка%li%' +
        '%li%%bold%Розыгрыш пройдет 17 января%bold% — занимайте топовые места рейтинга и переходите в лиги выше, чтобы получить билеты на розыгрыш. Чем их больше, тем выше шанс выиграть%li%' +
        '%ul%',
    },
    [GiftTabType.UserGifts]: {
      title: 'Ваши билетики на розыгрыш',
      descriptionTitle: 'Как получить еще',
      description:
        '%ul%' +
        '%li%Играйте активно, чтобы перейти в новую лигу и получить билет%li%' +
        '%li%Чем больше билетов соберете, тем выше шанс выиграть%li%' +
        '%li%Розыгрыш пройдет 17 января%li%' +
        '%ul%',
    },
  },
  GiftCardDescription: {
    closeTitle: 'Скрыть',
  },
  GiftCard: {
    descriptionTitle: 'Условия',
    disclaimerNotActive: 'Срок действия истек',
    disclaimerPending: 'Активируется через 15 минут',
  },
  GiftAction: {
    defaultText: 'Подключить',
    qrCodeText: 'Отсканируйте QR‑код, чтобы получить приз в приложении Т‑Банка',
  },
  GiftIcon: {
    defaultIconTypes: [
      GiftsIconDefaultType.Default1,
      GiftsIconDefaultType.Default2,
      GiftsIconDefaultType.Default3,
      GiftsIconDefaultType.Default4,
      GiftsIconDefaultType.Default5,
    ],
    defaultIcons: {
      [GiftsIconDefaultType.Default1]: {
        png: 'static/invest24/default1-280-2024-10-15-16-27-55.png 320w',
        avif: 'static/invest24/default1-280-2024-10-15-16-27-55.avif 854w',
        webp: 'static/invest24/default1-280-2024-10-15-16-27-55.webp 320w',
      },
      [GiftsIconDefaultType.Default2]: {
        png: 'static/invest24/default2-280-2024-10-15-16-27-55.png 320w',
        avif: 'static/invest24/default2-280-2024-10-15-16-27-55.avif 854w',
        webp: 'static/invest24/default2-280-2024-10-15-16-27-55.webp 320w',
      },
      [GiftsIconDefaultType.Default3]: {
        png: 'static/invest24/default3-280-2024-10-15-16-27-55.png 320w',
        avif: 'static/invest24/default3-280-2024-10-15-16-27-55.avif 320w',
        webp: 'static/invest24/default3-280-2024-10-15-16-27-55.webp 320w',
      },
      [GiftsIconDefaultType.Default4]: {
        png: 'static/invest24/default4-280-2024-10-15-16-27-55.png 320w',
        avif: 'static/invest24/default4-280-2024-10-15-16-27-55.avif 320w',
        webp: 'static/invest24/default4-280-2024-10-15-16-27-55.webp 320w',
      },
      [GiftsIconDefaultType.Default5]: {
        png: 'static/invest24/default5-280-2024-11-05-09-14-58.png 320w',
        avif: 'static/invest24/default5-280-2024-11-05-09-14-58.avif 854w',
        webp: 'static/invest24/default5-280-2024-11-05-09-14-58.webp 320w',
      },
    },
    icons: {
      [GiftsIconType.TPro]: {
        png: 'static/invest24/tProIcon-280-2024-10-15-16-29-32.png 320w',
        avif: 'static/invest24/tProIcon-280-2024-10-15-16-29-32.avif 320w',
        webp: 'static/invest24/tProIcon-280-2024-10-15-16-29-32.webp 320w',
      },
      [GiftsIconType.VK]: {
        png: 'static/invest24/vkIcon-280-2024-10-15-16-29-32.png 320w',
        avif: 'static/invest24/vkIcon-280-2024-10-15-16-29-32.avif 320w',
        webp: 'static/invest24/vkIcon-280-2024-10-15-16-29-32.webp 320w',
      },
      [GiftsIconType.TPremium]: {
        png: 'static/invest24/tPremiumIcon-280-2024-10-15-16-29-32.png 320w',
        avif: 'static/invest24/tPremiumIcon-280-2024-10-15-16-29-32.avif 320w',
        webp: 'static/invest24/tPremiumIcon-280-2024-10-15-16-29-32.webp 320w',
      },
      [GiftsIconType.TTravel]: {
        png: 'static/invest24/tTravelIcon-280-2024-10-15-16-29-32.png 320w',
        avif: 'static/invest24/tTravelIcon-280-2024-10-15-16-29-32.avif 320w',
        webp: 'static/invest24/tTravelIcon-280-2024-10-15-16-29-32.webp 320w',
      },
      [GiftsIconType.TInsurance]: {
        png: 'static/invest24/tInsuranceIcon-280-2024-10-15-16-29-32.png 320w',
        avif: 'static/invest24/tInsuranceIcon-280-2024-10-15-16-29-32.avif 320w',
        webp: 'static/invest24/tInsuranceIcon-280-2024-10-15-16-29-32.webp 320w',
      },
      [GiftsIconType.TInvest]: {
        png: 'static/invest24/tInvestIcon-280-2024-10-15-16-29-32.png 320w',
        avif: 'static/invest24/tInvestIcon-280-2024-10-15-16-29-32.avif 320w',
        webp: 'static/invest24/tInvestIcon-280-2024-10-15-16-29-32.webp 320w',
      },
      [GiftsIconType.TAfisha]: {
        png: 'static/invest24/tAfishaIcon-280-2024-11-05-09-03-17.png 320w',
        avif: 'static/invest24/tAfishaIcon-280-2024-11-05-09-03-17.avif 854w',
        webp: 'static/invest24/tAfishaIcon-280-2024-11-05-09-03-17.webp 320w',
      },
      [GiftsIconType.TSupermarkets]: {
        png: 'static/invest24/tSupermarketIcon-280-2024-11-05-09-03-17.png 320w',
        avif: 'static/invest24/tSupermarketIcon-280-2024-11-05-09-03-17.avif 320w',
        webp: 'static/invest24/tSupermarketIcon-280-2024-11-05-09-03-17.webp 320w',
      },
      [GiftsIconType.TFuel]: {
        png: 'static/invest24/tFuelIcon-280-2024-11-05-09-03-17.png 320w',
        avif: 'static/invest24/tFuelIcon-280-2024-11-05-09-03-17.avif 320w',
        webp: 'static/invest24/tFuelIcon-280-2024-11-05-09-03-17.webp 320w',
      },
      [GiftsIconType.TShopping]: {
        png: 'static/invest24/tShoppingIcon-280-2024-11-05-09-03-17.png 320w',
        avif: 'static/invest24/tShoppingIcon-280-2024-11-05-09-03-17.avif 320w',
        webp: 'static/invest24/tShoppingIcon-280-2024-11-05-09-03-17.webp 320w',
      },
      [GiftsIconType.YandexPlus]: {
        png: 'static/invest24/YaPlusIcon-280-2024-11-05-09-03-17.png 320w',
        avif: 'static/invest24/YaPlusIcon-280-2024-11-05-09-03-17.avif 320w',
        webp: 'static/invest24/YaPlusIcon-280-2024-11-05-09-03-17.webp 320w',
      },
      [GiftsIconType.YandexLavka]: {
        png: 'static/invest24/YaLavkaIcon-280-2024-11-05-09-03-17.png 320w',
        avif: 'static/invest24/YaLavkaIcon-280-2024-11-05-09-03-17.avif 320w',
        webp: 'static/invest24/YaLavkaIcon-280-2024-11-05-09-03-17.webp 320w',
      },
      [GiftsIconType.Yandex360]: {
        png: 'static/invest24/Ya360Icon-280-2024-11-21-09-42-16.png 320w',
        avif: 'static/invest24/Ya360Icon-280-2024-11-21-09-42-16.avif 320w',
        webp: 'static/invest24/Ya360Icon-280-2024-11-21-09-42-16.webp 320w',
      },
      [GiftsIconType.SberKuper]: {
        png: 'static/invest24/kuperIcon-280-2024-11-05-09-03-16.png 320w',
        avif: 'static/invest24/kuperIcon-280-2024-11-05-09-03-16.avif 854w',
        webp: 'static/invest24/kuperIcon-280-2024-11-05-09-03-16.webp 320w',
      },
      [GiftsIconType.TastyCoffee]: {
        png: 'static/invest24/tastyCoffeeIcon-280-2024-11-05-09-03-16.png 320w',
        avif: 'static/invest24/tastyCoffeeIcon-280-2024-11-05-09-03-16.avif 320w',
        webp: 'static/invest24/tastyCoffeeIcon-280-2024-11-05-09-03-16.webp 320w',
      },
      [GiftsIconType.WineLab]: {
        png: 'static/invest24/WinLabIcon-280-2024-11-05-09-03-17.png 320w',
        avif: 'static/invest24/WinLabIcon-280-2024-11-05-09-03-17.avif 320w',
        webp: 'static/invest24/WinLabIcon-280-2024-11-05-09-03-17.webp 320w',
      },
      [GiftsIconType.Delimobil]: {
        png: 'static/invest24/DelimobilIcon-280-2024-11-21-09-42-15.png 320w',
        avif: 'static/invest24/DelimobilIcon-280-2024-11-21-09-42-15.avif 320w',
        webp: 'static/invest24/DelimobilIcon-280-2024-11-21-09-42-15.webp 320w',
      },
      [GiftsIconType.Podruzka]: {
        png: 'static/invest24/PodruzkaIcon-280-2024-11-21-09-42-15.png 320w',
        avif: 'static/invest24/PodruzkaIcon-280-2024-11-21-09-42-15.avif 320w',
        webp: 'static/invest24/PodruzkaIcon-280-2024-11-21-09-42-15.webp 320w',
      },
      [GiftsIconType.Start]: {
        png: 'static/invest24/StartIcon-280-2024-11-21-09-42-15.png 320w',
        avif: 'static/invest24/StartIcon-280-2024-11-21-09-42-15.avif 854w',
        webp: 'static/invest24/StartIcon-280-2024-11-21-09-42-15.webp 320w',
      },
      [GiftsIconType.SkyEng]: {
        png: 'static/invest24/SkyEngIcon-280-2024-11-21-09-42-15.png 320w',
        avif: 'static/invest24/SkyEngIcon-280-2024-11-21-09-42-15.avif 320w',
        webp: 'static/invest24/SkyEngIcon-280-2024-11-21-09-42-15.webp 320w',
      },
      [GiftsIconType.Common]: {
        png: 'static/invest24/common-280-2024-11-05-09-03-16.png 320w',
        avif: 'static/invest24/common-280-2024-11-05-09-03-16.avif 854w',
        webp: 'static/invest24/common-280-2024-11-05-09-03-16.webp 320w',
      },
    },
    alt: 'Подарок',
  },
  GiftEmptyCard: {
    title: 'Здесь пока пусто',
    description: 'Покупайте улучшения, чтобы подняться в рейтинге своей лиги и получить призы',
    image: {
      src: {
        png: 'static/invest24/giftsEmpty-320-2024-10-09-12-26-02.png 320w, static/invest24/giftsEmpty-640-2024-10-09-12-26-02.png 854w',
        avif: 'static/invest24/giftsEmpty-320-2024-10-09-12-26-02.avif 320w, static/invest24/giftsEmpty-640-2024-10-09-12-26-02.avif 854w',
        webp: 'static/invest24/giftsEmpty-320-2024-10-09-12-26-02.webp 320w, static/invest24/giftsEmpty-640-2024-10-09-12-26-02.webp 854w',
      },
      alt: 'Подарок',
    },
  },
  LeagueRecalculationKotletkaText: [
    'Новый космический корабль на орбите! Мы обновили локацию и пересчитали лиги. Загляните и проверьте, как изменилось ваше положение в рейтинге',
    'Пересчет лиг завершен. Новые звезды зажглись на небосклоне инвесторов. Зайдите и узнайте, стали ли вы одной из них',
    'Внимание, космонавты! Мы достигли новой галактики. Лиги обновлены, рейтинги пересчитаны. Проверьте свои координаты на карте успеха',
    'Горячие новости из центра управления полетами! Локация обновлена, лиги пересчитаны. Возможно, вы уже в Алмазной лиге. Скорее проверьте',
  ],
  tooltips: {
    [TooltipId.OpenSettings]: {
      text: 'Котлетке скучно без музыки. Вы можете включить ее в настройках',
      placement: 'bottom',
    },
    [TooltipId.OpenDailyGame]: {
      text: 'Нажмите, чтобы добыть больше кристаллов',
      placement: 'left',
    },
    [TooltipId.SoonRecalculation]: {
      text: 'Сегодня в 00:00 по мск финальный пересчет лиг. Советую поднажать на тапы!',
      placement: 'top',
    },
  },
  OnboardingText: {
    [MainOnboardingStartSteps.StartWithGift]: {
      text: 'Привет! Я денежная Котлетка. Покажу, как играть и заработать первый приз',
      continueButtonText: 'Вперед! Хочу приз',
      skipButtonText: 'Пропущу, я профи в «Хомяке»',
      kotletkaImageBody: {
        png: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.png 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.png 854w',
        avif: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.avif 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.avif 854w',
        webp: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.webp 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.webp 854w',
      },
      kotletkaImageFingers: {
        png: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.png 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.png 854w',
        avif: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.avif 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.avif 854w',
        webp: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.webp 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.webp 854w',
      },
    },
    [MainOnboardingStartSteps.StartCommon]: {
      text: 'Привет! Я денежная Котлетка. Покажу, как играть и быстро набирать очки',
      continueButtonText: 'Вперед!',
      skipButtonText: 'Пропущу, я профи в «Хомяке»',
      kotletkaImageBody: {
        png: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.png 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.png 854w',
        avif: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.avif 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.avif 854w',
        webp: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.webp 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.webp 854w',
      },
      kotletkaImageFingers: {
        png: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.png 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.png 854w',
        avif: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.avif 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.avif 854w',
        webp: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.webp 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.webp 854w',
      },
    },
    [MainOnboardingSteps.Taps]: {
      text: 'Тапайте, чтобы добывать кристаллы. Можно сразу всеми пальцами!',
      placement: 'top',
    },
    [MainOnboardingSteps.CrystalCounter]: {
      text: 'Счетчик показывает, сколько вы собрали кристаллов',
      placement: 'bottom',
    },
    [MainOnboardingSteps.OpenImprovements]: {
      text: 'Инвестируйте кристаллы в улучшения. Нажмите, чтобы перейти в этот раздел',
      placement: 'top',
    },
    [MainOnboardingSteps.BuyImprovement]: {
      text: 'Каждое улучшение увеличивает ваш пассивный доход. Выберите Спутник связи и купите его',
      placement: 'top',
    },
    [MainOnboardingSteps.MinePerHour]: {
      text: 'Теперь вы получаете пассивный доход. Чем он больше, тем выше ваш рейтинг в лиге игроков',
      placement: 'bottom',
    },
    [MainOnboardingSteps.LeaderboardLocked]: {
      text: 'Посмотреть рейтинг можно тут. Пока подбираем вам соперников, вернитесь на главный экран',
      placement: 'bottom',
    },
    [MainOnboardingSteps.ContinueTap]: {
      text: 'Заработайте еще 30 кристаллов',
      placement: 'top',
    },
    [MainOnboardingSteps.OpenTasks]: {
      text: 'Тапы тратят энергию. Выполняйте задания, чтобы заряжать батарею. Посмотрите, что можно выполнить уже сейчас',
      placement: 'top',
    },
    [MainOnboardingSteps.BackToMainFromTasks]: {
      text: 'Вернитесь на главный экран игры',
      placement: 'top',
    },
    [MainOnboardingFinishSteps.FinishWithViewGift]: {
      text: 'Поздравляю! Вы узнали основы игры и заслужили награду. Скорее заберите свой приз и начните покорять космос',
      placement: 'bottom',
    },
    [MainOnboardingFinishSteps.FinishWithoutGift]: {
      text: 'Поздравляю! Теперь вы готовы к космическому приключению. Вперед, к новым высотам и ценным призам!',
      placement: 'top',
    },
    [DailyGameOnboardingSteps.SelectSymbol]: {
      text: 'Выберите букву',
      placement: 'top',
    },
    [DailyGameOnboardingSteps.CheckTip]: {
      text: 'Посмотрите подсказку, если трудно',
      placement: 'bottom',
    },
    [DailyGameOnboardingSteps.NextGame]: {
      text: 'Отгадывайте тикеры каждый день. Следующая мини‑игра через %time%',
      placement: 'left',
    },
  },
  Settings: {
    title: 'Настройки',
    exitButtonText: 'Выйти',
    showNewInvestGameOnStatusGameFinishedBeforeResults: true,
  },
  SettingsNewInvestGame: {
    title: 'Новая игра «Завод» от Т‑Инвестиций',
    subtitle:
      '%ul%%li%Отправляйтесь на завод, где каждый добытый слиток приближает вас к победе%li%%li%Как найти игру в приложении Т‑Инвестиций: «Чаты» → чат «Завод»%li%%ul%',
    image: {
      png: 'static/invest24/shahtiIcon-210-2024-12-04-14-51-10.png 320w',
      avif: 'static/invest24/shahtiIcon-210-2024-12-04-14-51-10.avif 320w',
      webp: 'static/invest24/shahtiIcon-210-2024-12-04-14-51-10.webp 320w',
    },
    // cta: {
    //   text: 'Подробнее',
    //   href: {
    //     mobileLink: 'tinkoffbank://Main/ShowCustomStory?storyId=44329',
    //     mobileLinkIos: 'https://l.tbank.ru/zavod_ios',
    //     mbAppDeeplink: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/ShowCustomStory?storyId=44329',
    //     investAppDeeplink: 'tcsgames://action/browser?link=tinkoffbank://Main/ShowCustomStory?storyId=44329',
    //   },
    // },
  },
  SettingsTogglesList: {
    settingsList: [
      {
        type: SettingsType.Reminders,
        trackingType: AnalyticsSettingsSwitchType.Notifications,
        text: 'Уведомления',
      },
      {
        type: SettingsType.Music,
        trackingType: AnalyticsSettingsSwitchType.Music,
        text: 'Музыка',
      },
      {
        type: SettingsType.Sounds,
        trackingType: AnalyticsSettingsSwitchType.Sounds,
        text: 'Звуки',
      },
      {
        type: SettingsType.PerformanceMode,
        trackingType: AnalyticsSettingsSwitchType.SpeedUp,
        text: 'Отключить анимации',
      },
    ],
  },
  SettingsFaq: {
    title: 'Ответы на вопросы',
    settingsQuestions: [],
  },
  FindAppImage: {
    src: {
      png: 'static/invest24/find_app-320-2024-11-15-14-40-55.png 320w, static/invest24/find_app-716-2024-11-15-14-40-55.png 854w',
      avif: 'static/invest24/find_app-320-2024-11-15-14-40-55.avif 320w, static/invest24/find_app-716-2024-11-15-14-40-55.avif 854w',
      webp: 'static/invest24/find_app-320-2024-11-15-14-40-55.webp 320w, static/invest24/find_app-716-2024-11-15-14-40-55.webp 1387w',
    },
    alt: 'Как найти игру в приложении Т‑Банка?',
  },
  FindAppButton: {
    text: 'Открыть в приложении',
    qrCodeText: 'Отсканируйте QR‑код чтобы открыть приложение',
    linkDefault: 'https://t.tb.ru/space-investors-landing-button',
    linkIos: 'https://l.tbank.ru/space-investors-landing-qr-button-ios',
  },
  HTMLClickerGame: {
    kotletka: {
      png: 'static/invest24/kotletka_default_full-320-2024-11-20-08-40-59.png 320w, static/invest24/kotletka_default_full-644-2024-11-20-08-40-59.png 854w',
      avif: 'static/invest24/kotletka_default_full-320-2024-11-20-08-40-59.avif 320w, static/invest24/kotletka_default_full-644-2024-11-20-08-40-59.avif 854w',
      webp: 'static/invest24/kotletka_default_full-320-2024-11-20-08-40-59.webp 320w, static/invest24/kotletka_default_full-644-2024-11-20-08-40-59.webp 854w',
    },
  },
  StatisticsLeagueProgress: {
    title: 'Ваш прогресс в лигах',
    weekTitle: 'Неделя',
    placementTitle: 'Место',
    leagueTitle: 'Лига',
    leagueName: {
      0: LeagueType.Bronze,
      1: LeagueType.Silver,
      2: LeagueType.Gold,
      3: LeagueType.Diamond,
    },
  },
  StatisticsHeader: {
    title: 'Игровая статистика',
  },
  StatisticsTabs: {
    personal: 'Персональная',
    project: 'Общая',
  },
  StatisticsList: {
    personal: {
      order: [
        PersonalGameStatisticsItem.PersonalEnergyMultiplier,
        PersonalGameStatisticsItem.PersonalEnergyRechargers,
        PersonalGameStatisticsItem.PersonalIncomePerHour,
        PersonalGameStatisticsItem.PersonalActiveGems,
        PersonalGameStatisticsItem.PersonalPassiveGems,
        PersonalGameStatisticsItem.PersonalImprovements,
        PersonalGameStatisticsItem.PersonalImprovementUpgrades,
        PersonalGameStatisticsItem.PersonalGifts,
        PersonalGameStatisticsItem.PersonalTasks,
        PersonalGameStatisticsItem.PersonalDailyGames,
        PersonalGameStatisticsItem.PersonalTickets,
        PersonalGameStatisticsItem.PersonalLeagueProgress,
        PersonalGameStatisticsItem.PersonalEnergySpent,
        PersonalGameStatisticsItem.PersonalEnergyRechargersSpent,
        PersonalGameStatisticsItem.PersonalGemsSpent,
      ],
      names: {
        [PersonalGameStatisticsItem.PersonalEnergyMultiplier]: 'Показатель мультитапа',
        [PersonalGameStatisticsItem.PersonalEnergyRechargers]: 'Заработано батареек',
        [PersonalGameStatisticsItem.PersonalIncomePerHour]: 'Доход в час',
        [PersonalGameStatisticsItem.PersonalActiveGems]: 'Заработано кристаллов за тапы',
        [PersonalGameStatisticsItem.PersonalPassiveGems]: 'Заработано кристаллов за улучшения',
        [PersonalGameStatisticsItem.PersonalImprovements]: 'Куплено улучшений первого уровня',
        [PersonalGameStatisticsItem.PersonalImprovementUpgrades]: 'Прокачено улучшений',
        [PersonalGameStatisticsItem.PersonalGifts]: 'Получено призов',
        [PersonalGameStatisticsItem.PersonalTasks]: 'Выполнено заданий',
        [PersonalGameStatisticsItem.PersonalDailyGames]: 'Пройдено мини‑игр',
        [PersonalGameStatisticsItem.PersonalTickets]: 'Собрано билетов на розыгрыш',
        [PersonalGameStatisticsItem.PersonalEnergySpent]: 'Количество тапов',
        [PersonalGameStatisticsItem.PersonalEnergyRechargersSpent]: 'Потрачено батареек',
        [PersonalGameStatisticsItem.PersonalGemsSpent]: 'Потрачено кристаллов',
      },
    },
    project: [
      {
        id: 'totalTaps',
        name: 'Всего совершено тапов',
        value: '25,2 млрд',
      },
      {
        id: 'totalEnergyRechargers',
        name: 'Всего заработано батареек',
        value: '14 097 406',
      },
      {
        id: 'totalEnergyRechargersSpent',
        name: 'Всего потрачено батареек',
        value: '9 377 834',
      },
      {
        id: 'totalIncome',
        name: 'Суммарный доход в час',
        value: '252,5 млрд',
      },
      {
        id: 'totalEarnedForTaps',
        name: 'Всего заработано кристаллов за тапы',
        value: '5,5 трлн',
      },
      {
        id: 'totalEarnedPassive',
        name: 'Всего заработано кристаллов за улучшения',
        value: '41,3 трлн',
      },
      {
        id: 'openedImprovements',
        name: 'Всего куплено улучшений первого уровня',
        value: '5 594 142',
      },
      {
        id: 'boughtImprovements',
        name: 'Всего прокачено улучшений',
        value: '130 330 566',
      },
      {
        id: 'completedTasks',
        name: 'Всего выполнено заданий',
        value: '3 312 583',
      },
      {
        id: 'giftsReceived',
        name: 'Всего получено призов',
        value: '3 065 935',
      },
      {
        id: 'totalMiniGames',
        name: 'Всего пройдено игр',
        value: '3 859 493',
      },
      // {
      //   id: 'diamondLeagueUserCount',
      //   name: 'Всего дошло до алмазной лиги',
      //   value: '7 400',
      // },
    ] as ProjectGameStatisticsItem[],
    emptyListText: 'Подводим итоги игры, скоро тут появится общая игровая статистика',
  },
  ResultsStartModal: {
    gameFinishedBeforeResults: {
      title: 'Игра закончилась',
      subtitle: 'Розыгрыш уже сегодня! Подводим результаты и опубликуем победителей в течение дня. Возвращайтесь позже',
      ctaFirstText: 'Смотреть призы',
      ctaSecondText: 'Тап‑тап‑таааапать',
    },
    gameFinishedAfterResults: {
      title: 'Игра закончилась',
      subtitle: '17 января выбрали победителей случайным образом. Вы можете посмотреть, как это было',
      ctaFirstText: 'Посмотреть',
    },
  },
  ResultsStartModalBase: {
    kotletkaImageBody: {
      png: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.png 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.png 854w',
      avif: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.avif 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.avif 854w',
      webp: 'static/invest24/kotletka_onboarding_body-320-2024-10-23-14-53-24.webp 320w, static/invest24/kotletka_onboarding_body-420-2024-10-23-14-53-24.webp 854w',
    },
    kotletkaImageFingers: {
      png: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.png 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.png 854w',
      avif: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.avif 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.avif 854w',
      webp: 'static/invest24/kotletka_onboarding_fingers-320-2024-10-23-14-54-49.webp 320w, static/invest24/kotletka_onboarding_fingers-449-2024-10-23-14-54-49.webp 854w',
    },
  },
  BeforeResultsInfoHeader: {
    title: 'Розыгрыш призов',
    description: 'Выберем победителей случайным образом 17 января и опубликуем результаты на этой странице',
    ctaText: 'Здесь будет запись розыгрыша',
    modal: {
      title: 'Какие призы',
      description: [
        '%yellow%1 500 000₽%yellow% — денежный фонд разделят 100 игроков, каждый получит по 15 000 ₽',
        '%yellow%Портфель акций%yellow% — 65 победителей получат активы от Т‑Инвестиций стоимостью до 15 000 ₽',
        '%yellow%Кэшбэк до 100% в T-Shop%yellow% — 65 победителей смогут выгодно закупиться в магазине мерча Т‑Банка',
      ],
    },
  },
  BeforeResultsInfoTickets: {
    emptyTicketsText: 'Вы не успели получить билеты',
  },
  GiftTicketGameFinishedCard: {
    [GameStatusType.GameFinishedBeforeResults]: {
      title: 'Мои билеты на розыгрыш',
      descriptionTitle: 'Подробнее',
      description:
        '%ul%' +
        '%li%Вы получали билеты за то, что занимали топовые места в лигах%li%' +
        '%li%Чем больше у вас билетов, тем выше шанс выиграть в розыгрыше%li%' +
        '%li%Розыгрыш пройдет 17 января%li%' +
        '%ul%',
    },
    [GameStatusType.GameFinishedAfterResults]: {
      title: 'Мои билеты',
      descriptionTitle: 'Подробнее',
      description: '',
    },
  },
  GiftsGameFinishedHeader: {
    title: 'Мои призы',
    description: 'Эти же призы вы можете найти в разделе «Кэшбэк и бонусы» в приложении Т‑Банка',
    winnersButtonText: 'Победители розыгрыша',
  },
  GiftsGameFinishedList: {
    emptyListText: 'За время проекта вы не успели получить призы и билеты',
  },
  GiftGameFinishedBeforeResultsCard: {
    title: '17 января разыграем 1 500 000 ₽ и другие призы',
    descriptionTitle: 'Подробнее',
    description:
      '%ul%%li%1 500 000 ₽ — денежный фонд разделят 100 игроков, каждый получит по 15 000 ₽%li%%li%Портфель акций — 65 победителей получат активы от Т‑Инвестиций стоимостью до 15 000 ₽%li%%li%Кэшбэк до 100% в T-Shop — 65 победителей смогут выгодно закупиться в магазине мерча Т‑Банка%li%%ul%',
  },
  GiftGameFinishedAfterResultsCard: {
    [ResultGiftType.Money]: {
      iconType: GiftsIconDefaultType.Default2,
      title: '15 000 ₽',
      descriptionTitle: 'Условия',
      description: 'Деньги придут на вашу карту Т‑Банка до 17 февраля 2025 года',
      cta: null,
    },
    [ResultGiftType.Stocks]: {
      iconType: GiftsIconDefaultType.Default1,
      title: 'Портфель акций на сумму до 15 000 ₽',
      descriptionTitle: 'Условия',
      description: 'Активы появятся на вашем брокерском счете до 17 февраля 2025 года',
      cta: null,
    },
    [ResultGiftType.TShop]: {
      iconType: GiftsIconDefaultType.Default3,
      title: 'Кэшбэк до 100% в T-Shop',
      descriptionTitle: 'Условия',
      description:
        'Сделайте покупку на shop.tbank.ru до 9 февраля 2025 года и оплатите ее своей картой Т‑Банка. Кэшбэк придет до 17 февраля. Максимальная сумма кэшбэка 15 000 ₽',
      cta: null,
    },
  },
  LeaderBoardGameFinishedHeader: {
    title: {
      [LeagueType.Bronze]: 'Бронзовая лига',
      [LeagueType.Silver]: 'Серебряная лига',
      [LeagueType.Gold]: 'Золотая лига',
      [LeagueType.Diamond]: 'Алмазная лига',
    },
  },
  LeaderBoardGameFinishedNewCard: {
    title: 'Нет рейтинга',
    description:
      'Подбирали соперников после покупки первого улучшения. Вы не покупали улучшений, поэтому рейтинг не был сформирован.',
  },
  UserResultGiftModal: {
    kotletkaImage: 'https://ps-static.cdn-tinkoff.ru/static/invest24/fireflies_spritesheet-2024-12-11-12-53-43.png',
    title: 'Вы победили в розыгрыше!',
    text: 'Перейдите в раздел с призами и узнайте, как получить и использовать выигрыш',
    openGiftsText: 'Мои призы',
    prizes: {
      [ResultGiftType.Stocks]: 'Портфель акций на сумму до 15 000 ₽',
      [ResultGiftType.Money]: '15 000 ₽',
      [ResultGiftType.TShop]: 'Кэшбэк до 100% в T-Shop',
    },
  },
  WinnersPage: {
    kotletkaImage: 'https://ps-static.cdn-tinkoff.ru/static/invest24/fireflies_spritesheet-2024-12-11-12-53-43.png',
  },
  WinnersHeader: {
    title: 'Победители розыгрыша',
    description: '17 января выбрали победителей случайным образом. Вы можете посмотреть, как это было',
    buttonCopy: {
      link: 'https://rutube.ru/video/80d30d64b9e2737408ad8f2373845875/',
      textDefault: 'Скопировать ссылку на розыгрыш',
      textCopied: 'Ссылка скопирована',
    },
    buttonLink: {
      link: 'https://rutube.ru/video/80d30d64b9e2737408ad8f2373845875/',
      text: 'Запись розыгрыша призов',
    },
    buttonTerms: {
      text: 'Условия получения призов',
      link: {
        smallVersion: 'https://cdn.tbank.ru/static/documents/promo-space-investors-m.pdf',
        bigVersion: 'https://cdn.tbank.ru/static/documents/promo-space-investors.pdf',
      },
    },
  },
  WinnersTabs: {
    tabs: {
      money: 'Деньги',
      stocks: 'Акции',
      tShop: 'Кэшбэк в T-shop',
    },
    subtitles: {
      [ResultGiftType.Money]: 'Фонд 1 500 000 ₽ делят 100 игроков, каждый получает по 15 000 ₽',
      [ResultGiftType.Stocks]: '65 победителей получают портфели акций от Т‑Инвестиций стоимостью до 15 000 ₽',
      [ResultGiftType.TShop]: '65 победителей могут закупиться в магазине мерча Т‑Банка с кэшбэком до 100%',
    },
  },
  WinnersList: {
    backButtonText: 'Вернуться в начало',
  },
  GiftsGameMocksHeader: {
    title: 'Призы',
    description:
      'Призы и билеты для участия в розыгрыше получали клиенты, занимавшие верхние места в лигах %yellow%по доходу в час.%yellow% Лиги пересчитывались в конце каждой недели.',
    leaderboardButtonText: 'Пример рейтинга',
  },
  GiftsGameMocksList: {
    gifts: [
      {
        type: GiftType.Static,
        title: 'Акции в Т‑Инвестициях',
        iconType: GiftsIconType.TInvest,
      },
      {
        type: GiftType.Static,
        title: '2 месяца с подпиской Pro в Т‑Банке',
        iconType: GiftsIconType.TPro,
      },
      {
        type: GiftType.Static,
        title: 'Яндекс Плюс: до 60 дней бесплатно',
        iconType: GiftsIconType.YandexPlus,
      },
      {
        type: GiftType.Static,
        title: 'Кэшбэк 15% за покупку в Шопинге',
        iconType: GiftsIconType.TShopping,
      },
      {
        type: GiftType.Static,
        title: 'Скидка 1000 ₽ на первую поездку в Делимобиль',
        iconType: GiftsIconType.Delimobil,
      },
      {
        type: GiftType.Static,
        title: 'Скидка 50% на все виды годовых подписок Яндекс 360',
        iconType: GiftsIconType.Yandex360,
      },
    ] as GiftStatic[],
  },
  GiftGameMocksCard: {
    title: '17 января разыграли 1 500 000 рублей и другие призы',
    descriptionTitle: 'Подробнее',
    description:
      '%ul%' +
      '%li%1 500 000 ₽ — денежный фонд разделили 100 игроков, каждый получил по 15 000 ₽%li%' +
      '%li%Портфель акций — 65 победителей получили активы от Т‑Инвестиций стоимостью до 15 000 ₽%li%' +
      '%li%Кэшбэк до 100% в T-Shop — 65 победителей смогли выгодно закупиться в магазине мерча Т‑Банка%li%' +
      '%ul%',
  },
  StatisticsMocksHeader: {
    title: 'Общая статистика',
  },
  winners: [
    {
      type: ResultGiftType.Money,
      id: '01JDNW803AMKABZX5MMBNS9NAR',
      name: 'Александра Д. В.',
      phone: '+7 *** *** 34 48',
      ticket: '008-348-76',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNYWKQ68W9388VD323GK8NG',
      name: 'Александра О. П.',
      phone: '+7 *** *** 43 88',
      ticket: '000-884-37',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNRMJGF2M8Z6FARAARKJ3SC',
      name: 'Данил А. П.',
      phone: '+7 *** *** 74 25',
      ticket: '002-490-59',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE4J9R1Q56TRC5GSE8M479SH',
      name: 'Елена Д. Щ.',
      phone: '+7 *** *** 20 63',
      ticket: '005-013-47',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNAJJT760HE91XZ1VQ6MEGN',
      name: 'Артём Л. Т.',
      phone: '+7 *** *** 02 03',
      ticket: '000-430-58',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDN5PS7C9MXRJ6VV5KRJHG7K',
      name: 'Евгений Г. А.',
      phone: '+7 *** *** 00 94',
      ticket: '000-208-47',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDMJQKS1HQ2D2N5K1RFJ6Y3N',
      name: 'Владимир Н. В.',
      phone: '+7 *** *** 12 64',
      ticket: '000-218-18',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEKNRCS3V4VJVVV8HZZSS025',
      name: 'Егор Б. В.',
      phone: '+7 *** *** 58 79',
      ticket: '007-282-91',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNYS0KTMZH0MNJ8GY451507',
      name: 'Вера В. А.',
      phone: '+7 *** *** 31 90',
      ticket: '006-556-38',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEJAT5V80P2XMCWGB4VGWA8G',
      name: 'Иван А. Б.',
      phone: '+7 *** *** 29 59',
      ticket: '005-314-25',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDP52QNETZSWG4BFB9500HNP',
      name: 'Евгений В. Ф.',
      phone: '+7 *** *** 94 80',
      ticket: '000-916-50',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPW786T3K3XZRHFCF5MCSM8',
      name: 'Сергей В. Р.',
      phone: '+7 *** *** 09 08',
      ticket: '002-744-62',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPKHWHVSF1PW9CCE16YBXTY',
      name: 'Светлана Ю. К.',
      phone: '+7 *** *** 88 82',
      ticket: '005-844-33',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNTFWD8H4BZE2C4VG3YB8HX',
      name: 'Денис Э. Б.',
      phone: '+7 *** *** 65 60',
      ticket: '000-682-34',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDWDMXNX8ECQG5FA2XQR5F52',
      name: 'Екатерина И. С.',
      phone: '+7 *** *** 58 75',
      ticket: '001-341-91',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEKD1X5F957WS7KPPVH7VX0P',
      name: 'Марат Э. Х.',
      phone: '+7 *** *** 09 55',
      ticket: '011-887-09',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEV5MN4SRA75T53W59FQV3SX',
      name: 'Данил Э. Г.',
      phone: '+7 *** *** 74 23',
      ticket: '009-417-62',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE97VBWH3TQC0T48CN965VX0',
      name: 'Владислава Д. З.',
      phone: '+7 *** *** 19 21',
      ticket: '008-032-52',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDZ3JXPAG3GSSPQ1F1BE7178',
      name: 'Анастасия А. С.',
      phone: '+7 *** *** 51 59',
      ticket: '010-559-07',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNYKQD9J9010E8NQ4SSZ871',
      name: 'Михаил В. К.',
      phone: '+7 *** *** 73 78',
      ticket: '005-912-95',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEKGT3WC3D8E5CZDNW6KZ9ZW',
      name: 'Юрий С. Д.',
      phone: '+7 *** *** 51 32',
      ticket: '005-462-88',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDQ026XZKW00X9FGTP9YCEP7',
      name: 'Михаил Е. Л.',
      phone: '+7 *** *** 06 80',
      ticket: '002-709-62',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPSMKY78CM1P7MK02540JPP',
      name: 'Полина Н. С.',
      phone: '+7 *** *** 32 44',
      ticket: '011-381-51',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDWD74RN3WCPAGAPW6TFMEAR',
      name: 'Николай П. В.',
      phone: '+7 *** *** 61 36',
      ticket: '005-647-32',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE8C0K316DGHRVDB99VRPYPG',
      name: 'Алексей В. Д.',
      phone: '+7 *** *** 36 88',
      ticket: '005-320-74',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNWVJ32BD6HXCNQSC0BA115',
      name: 'Андрей А. З.',
      phone: '+7 *** *** 96 72',
      ticket: '007-545-35',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDP6981NH73SFDDRXF8P9TT1',
      name: 'Ольга В. П.',
      phone: '+7 *** *** 70 62',
      ticket: '004-096-55',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE6F9JZ85PNA9720C5JW48ME',
      name: 'Павел В. П.',
      phone: '+7 *** *** 24 79',
      ticket: '005-371-73',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE3S0PGFW94P0SCQW6SEG96G',
      name: 'Александр Г. П.',
      phone: '+7 *** *** 14 16',
      ticket: '006-829-89',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEGKT06CJCNB1M413GFG1FP6',
      name: 'Валентина В. Н.',
      phone: '+7 *** *** 59 96',
      ticket: '004-714-98',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDQ89PQN6J8JTST2F2MXTWV1',
      name: 'Эмиль Р. Т.',
      phone: '+7 *** *** 64 77',
      ticket: '002-007-00',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEPHB6VWWTX4DTFXG7ZTKACH',
      name: 'Максим Д. А.',
      phone: '+7 *** *** 10 44',
      ticket: '008-483-03',
    },
    {
      type: ResultGiftType.Money,
      id: '01JERDYRD3EHA722SYRJWDJ5H7',
      name: 'Юлия В. Л.',
      phone: '+7 *** *** 05 88',
      ticket: '008-701-60',
    },
    {
      type: ResultGiftType.Money,
      id: '01JETQ4292RTN52S0DAA5JW9VF',
      name: 'Сергей В. Н.',
      phone: '+7 *** *** 59 80',
      ticket: '010-655-05',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPMRPZ0ERBS1HQ57HZ3HYYX',
      name: 'Елена В. Б.',
      phone: '+7 *** *** 54 13',
      ticket: '003-671-76',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDZKFS9PXGGB5B9MVBHH6ZR1',
      name: 'Мария С. Д.',
      phone: '+7 *** *** 18 09',
      ticket: '002-094-64',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEDDNCXJ59Q9Y0HEZDZ7FP5G',
      name: 'Андрей Г. К.',
      phone: '+7 *** *** 29 39',
      ticket: '013-021-47',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNGJ0EZZZHQ58YGDAA9V1A8',
      name: 'Денис В. Ч.',
      phone: '+7 *** *** 62 02',
      ticket: '002-418-14',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE3BATC616WTW68ZCNTM4FNY',
      name: 'Стефания Д. Б.',
      phone: '+7 *** *** 20 03',
      ticket: '003-902-15',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE4A8QNEV4SBXK57JJAT25JP',
      name: 'Анастасия А. П.',
      phone: '+7 *** *** 64 44',
      ticket: '004-571-32',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE6BG93FK6H4AKJK29BWAS8J',
      name: 'Константин П. А.',
      phone: '+7 *** *** 14 11',
      ticket: '005-293-48',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE3ZSHHHHZF59TCHAAFNAXG4',
      name: 'Абдула М. П.',
      phone: '+7 *** *** 88 41',
      ticket: '004-829-84',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNYY3SWF5674788PT62E3N2',
      name: 'Артём П. Ш.',
      phone: '+7 *** *** 78 60',
      ticket: '004-668-93',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDP2H47VG2RR4ZCFHGJ09QVP',
      name: 'Даниил Д. Ж.',
      phone: '+7 *** *** 85 58',
      ticket: '003-383-00',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDQ84MGRNABQDJ7BHQX7K2PW',
      name: 'Раиса В. Б.',
      phone: '+7 *** *** 94 15',
      ticket: '002-725-41',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE3Q1YHK8H3M65RQ7XZ805BZ',
      name: 'Амалия А. А.',
      phone: '+7 *** *** 29 68',
      ticket: '009-173-35',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDP7GCF2QAGGFXPDWXHD6204',
      name: 'Александра В. О.',
      phone: '+7 *** *** 77 79',
      ticket: '000-567-61',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDW28AC29274TR8M622114PK',
      name: 'Мария Р. З.',
      phone: '+7 *** *** 95 21',
      ticket: '006-214-50',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEZK0NHKWYD4JQKAEECM7JDQ',
      name: 'Любовь Н. С.',
      phone: '+7 *** *** 95 93',
      ticket: '010-737-67',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE83ZHRWWENX0BXRR8PBXE7W',
      name: 'Максим А. Ч.',
      phone: '+7 *** *** 33 60',
      ticket: '010-830-74',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDP6EHMV57TFBQDGP40EZ1SD',
      name: 'Аделина А. Г.',
      phone: '+7 *** *** 90 44',
      ticket: '007-986-38',
    },
    {
      type: ResultGiftType.Money,
      id: '01JFQR2T3RYEFNHXCJ1AYPAKVH',
      name: 'Александр Г. М.',
      phone: '+7 *** *** 80 17',
      ticket: '012-466-90',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE6BBKG2KMSC2A7XD6H8T9R9',
      name: 'Данил Б. Ф.',
      phone: '+7 *** *** 98 07',
      ticket: '008-455-79',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE8BP4F7CS5PBB9DNWKHX4SC',
      name: 'Алексей В. А.',
      phone: '+7 *** *** 82 01',
      ticket: '010-878-86',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDN0G92P3K8HH8J5GZBG2Z04',
      name: 'Анастасия Ю. С.',
      phone: '+7 *** *** 25 48',
      ticket: '002-810-17',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNVN52XMSYM36JQ8B5H4X4W',
      name: 'Илья Е. П.',
      phone: '+7 *** *** 53 31',
      ticket: '000-782-62',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEXWW4XH789E93EQP8PWFC33',
      name: 'Дмитрий С. Г.',
      phone: '+7 *** *** 20 99',
      ticket: '009-020-67',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNVFJQVGNDDVA15XK6430WB',
      name: 'Надежда Н. С.',
      phone: '+7 *** *** 16 46',
      ticket: '000-766-45',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE2TFRC9YVZVY3SH3W546AW9',
      name: 'Степан Н. Д.',
      phone: '+7 *** *** 02 04',
      ticket: '004-039-26',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEB1S60XFDPRR7ERA2B6DJC3',
      name: 'Виктория С. К.',
      phone: '+7 *** *** 48 18',
      ticket: '005-567-50',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE1DGERWA68TS57HZN4D8KZF',
      name: 'Ярослав И. К.',
      phone: '+7 *** *** 00 06',
      ticket: '002-014-43',
    },
    {
      type: ResultGiftType.Money,
      id: '01JETSYRPJ4C8KD0HPMHPSEXSM',
      name: 'Александра Б. Р.',
      phone: '+7 *** *** 35 24',
      ticket: '009-654-90',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDP9AD8FPPKYJV6286F8J0TK',
      name: 'Татьяна С. В.',
      phone: '+7 *** *** 64 24',
      ticket: '000-515-36',
    },
    {
      type: ResultGiftType.Money,
      id: '01JF1Y92VX7QQR0RXQRVMD112Z',
      name: 'Владимир В. П.',
      phone: '+7 *** *** 06 91',
      ticket: '012-928-05',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDS1DSZZY4A1VQWGBQ9CASMF',
      name: 'Асан И. Х.',
      phone: '+7 *** *** 90 59',
      ticket: '001-283-59',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDRM47DN86Z64T537VMMCS7S',
      name: 'Антонина А. Л.',
      phone: '+7 *** *** 78 45',
      ticket: '001-731-40',
    },
    {
      type: ResultGiftType.Money,
      id: '01JF4S4JJYJCRAY54STR9WSPBA',
      name: 'Екатерина В. Ш.',
      phone: '+7 *** *** 93 11',
      ticket: '012-066-73',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDN5VX3ZT3B72HVQGHC6B0NZ',
      name: 'Полина К. М.',
      phone: '+7 *** *** 01 44',
      ticket: '002-447-11',
    },
    {
      type: ResultGiftType.Money,
      id: '01JF4H8N0NR7C7K0GM0ZQVVVHW',
      name: 'Иван В. П.',
      phone: '+7 *** *** 00 19',
      ticket: '009-326-32',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEK50KEJQSFJHJXWJ0FBZ5Q3',
      name: 'Павел С. Б.',
      phone: '+7 *** *** 15 53',
      ticket: '010-811-31',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDMM9CBTJ8RYEB9AAA4KK0BW',
      name: 'Ульяна Е. А.',
      phone: '+7 *** *** 96 56',
      ticket: '000-240-13',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE4CN59GAHMPR1RSZ6RPYVRE',
      name: 'Алексей А. Ж.',
      phone: '+7 *** *** 98 14',
      ticket: '007-991-37',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPN5KWDNXNWK47YNWBYKBZ7',
      name: 'Александр С. С.',
      phone: '+7 *** *** 24 23',
      ticket: '008-243-82',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNZS4NNNDCDRD0H81T9ZS6C',
      name: 'Максим А. Т.',
      phone: '+7 *** *** 56 25',
      ticket: '007-591-20',
    },
    {
      type: ResultGiftType.Money,
      id: '01JENEBB9FXXRR8HVHZFCN244A',
      name: 'Артем В. Р.',
      phone: '+7 *** *** 64 83',
      ticket: '008-387-40',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPSKF3K6NK8M6JFVHY188TF',
      name: 'Анна А. С.',
      phone: '+7 *** *** 96 89',
      ticket: '005-272-09',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEK81S9XYS647ZTD7PFP3D0D',
      name: 'Евгения С. М.',
      phone: '+7 *** *** 04 32',
      ticket: '007-277-94',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE66R5M8JX3XPEAGGQXN8Z6F',
      name: 'Роман В. Ш.',
      phone: '+7 *** *** 57 59',
      ticket: '010-580-35',
    },
    {
      type: ResultGiftType.Money,
      id: '01JF7QYDK2M71BXKXD0APC78P1',
      name: 'Евгений Д. С.',
      phone: '+7 *** *** 45 16',
      ticket: '010-764-99',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEBCYCDY8PM114VNCNERBB5A',
      name: 'Регина И. Г.',
      phone: '+7 *** *** 32 27',
      ticket: '011-595-95',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDWP43JTT83G9R1JZKA5ED59',
      name: 'Олег В. Г.',
      phone: '+7 *** *** 88 71',
      ticket: '001-361-54',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPNAVCD2QTWBZ08QRDVSQR8',
      name: 'Алексей Б. А.',
      phone: '+7 *** *** 03 63',
      ticket: '010-838-25',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE6P24FY15WQTRWPDG175S8B',
      name: 'Константин Г. Б.',
      phone: '+7 *** *** 34 57',
      ticket: '002-414-41',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNXY1AA51SQMEF4A4DXS3SV',
      name: 'Кирилл А. К.',
      phone: '+7 *** *** 92 01',
      ticket: '003-033-29',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE118Y515RBWN3QZ5FS9QWEQ',
      name: 'Рустам И. А.',
      phone: '+7 *** *** 06 74',
      ticket: '008-096-67',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDNYNX5RNVK9VCTJVSEAN256',
      name: 'Сергей Ю. Я.',
      phone: '+7 *** *** 10 87',
      ticket: '006-420-60',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDT6MSY9WJYGYC8AFPPXKK2T',
      name: 'Алла С. М.',
      phone: '+7 *** *** 03 65',
      ticket: '002-694-25',
    },
    {
      type: ResultGiftType.Money,
      id: '01JEEVB5PY32GXHA814BNMPEVP',
      name: 'Елена В. С.',
      phone: '+7 *** *** 65 51',
      ticket: '007-061-43',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPW6G077FED5RVNMGMTNC6J',
      name: 'Александр Д. Д.',
      phone: '+7 *** *** 53 48',
      ticket: '005-967-96',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDMN46VWXQJFEWRDYW3V1ERD',
      name: 'Александр В. К.',
      phone: '+7 *** *** 21 35',
      ticket: '000-280-53',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE3VPSQ919P8S1MGQXJ9D37F',
      name: 'Артем А. Х.',
      phone: '+7 *** *** 16 84',
      ticket: '005-760-93',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDRQDH05PYYRBHFPNN15QQ2V',
      name: 'Максим Д. Д.',
      phone: '+7 *** *** 20 17',
      ticket: '002-395-91',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDMHNG6YQC6KR1E2M1M3RBGN',
      name: 'Олег Д. К.',
      phone: '+7 *** *** 74 22',
      ticket: '000-230-80',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE3ZXAG2NT7T0PT3ADKV0B8P',
      name: 'Ирина Н. Д.',
      phone: '+7 *** *** 04 02',
      ticket: '004-836-81',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE858D6PT82MQTZZ9KYMS0QX',
      name: 'Ольга Л. Д.',
      phone: '+7 *** *** 87 53',
      ticket: '004-488-01',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDS1EP40M72RCCYRDG0J855H',
      name: 'Дмитрий М. Ш.',
      phone: '+7 *** *** 61 61',
      ticket: '001-016-15',
    },
    {
      type: ResultGiftType.Money,
      id: '01JE947Z7PZFCHDQ9D69SG4WDW',
      name: 'Надежда В. К.',
      phone: '+7 *** *** 17 93',
      ticket: '006-318-71',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPK45VE8FSABP61M4XF17R9',
      name: 'Сергей А. К.',
      phone: '+7 *** *** 31 14',
      ticket: '001-039-60',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDPS39QMAF23768B7XGZHR3H',
      name: 'Богдан Ю. Х.',
      phone: '+7 *** *** 35 06',
      ticket: '001-386-89',
    },
    {
      type: ResultGiftType.Money,
      id: '01JDWDC1RC82JPTGMNKGYQDFM2',
      name: 'Анастасия Т. Ш.',
      phone: '+7 *** *** 47 33',
      ticket: '001-684-85',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE87X37FD5QVBJKDNF45NSSD',
      name: 'Александра А. Ч.',
      phone: '+7 *** *** 31 01',
      ticket: '008-036-15',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE2YZV6BQY8FWMS65QS1N1G1',
      name: 'Виталий В. Л.',
      phone: '+7 *** *** 09 99',
      ticket: '004-073-95',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDN75S0D523Y2MCQ7KJH6BVT',
      name: 'Ольга А. К.',
      phone: '+7 *** *** 90 42',
      ticket: '000-381-95',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDWE5VXNMJBYSQ138CW4W1Z8',
      name: 'Владислав А. Л.',
      phone: '+7 *** *** 61 57',
      ticket: '002-608-42',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDP100RVKF85H478XZCR1GVX',
      name: 'Федор М. С.',
      phone: '+7 *** *** 44 88',
      ticket: '008-080-46',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDRHJ87DJMKNYTWYBBXZH1BE',
      name: 'Елена К. К.',
      phone: '+7 *** *** 60 06',
      ticket: '006-191-54',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE873YSTPQVZZVC4V2C40JKR',
      name: 'Кристина В. К.',
      phone: '+7 *** *** 71 58',
      ticket: '002-651-00',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDS2X049W74V5QSNJTB84DGV',
      name: 'Евгений В. Т.',
      phone: '+7 *** *** 00 62',
      ticket: '011-486-88',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE6GFW0TH80PDG1P0088S4CZ',
      name: 'Регина М. Ш.',
      phone: '+7 *** *** 58 85',
      ticket: '005-368-94',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDJSZYCTQFBSSY0ZGJYHMJPG',
      name: 'Дмитрий М. Н.',
      phone: '+7 *** *** 81 59',
      ticket: '000-003-03',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JETZT7Z804365Y9BGS4TDZ4F',
      name: 'Виктор Л. Л.',
      phone: '+7 *** *** 32 51',
      ticket: '008-863-63',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JFH0KGES0TB6G42NAT1CCD6M',
      name: 'Алексей А. Ф.',
      phone: '+7 *** *** 15 90',
      ticket: '012-600-18',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDNJZ9ZW11MXB0YRKFHG1XPG',
      name: 'Валентина В. А.',
      phone: '+7 *** *** 23 27',
      ticket: '000-032-72',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JF2K5XKT5ZSSMG05KFSBVTZF',
      name: 'Баудин Р. Г.',
      phone: '+7 *** *** 16 16',
      ticket: '009-233-00',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEK93MQKE8Y993QB6R3D77VW',
      name: 'Татьяна А. Г.',
      phone: '+7 *** *** 43 46',
      ticket: '011-919-26',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JF68M343KC47F0KQRF0664BV',
      name: 'Андрей С. Е.',
      phone: '+7 *** *** 57 95',
      ticket: '010-614-27',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE98NAKHWP3VERW1B278W5FW',
      name: 'Сергей И. Б.',
      phone: '+7 *** *** 50 98',
      ticket: '004-451-80',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDNFA2KX1JFH775FXYAC73HM',
      name: 'Анастасия В. К.',
      phone: '+7 *** *** 00 79',
      ticket: '011-672-17',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE34WR6RJ1JFWYRRTG47KNXK',
      name: 'Вадим В. Н.',
      phone: '+7 *** *** 50 90',
      ticket: '012-116-81',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDM7KTN26WSA188DB73G15XH',
      name: 'Дамир Р. В.',
      phone: '+7 *** *** 10 71',
      ticket: '000-100-97',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE3147DHD1TN478221ZSANJA',
      name: 'Егор В. С.',
      phone: '+7 *** *** 28 56',
      ticket: '006-484-53',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDVXBTQBNF5DNEHK0STXR3CP',
      name: 'Карина И. Т.',
      phone: '+7 *** *** 42 75',
      ticket: '001-610-88',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDRAX6V5NE4W83KS9SH80Q44',
      name: 'Сергей М. Ч.',
      phone: '+7 *** *** 18 50',
      ticket: '002-899-46',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDVKVDHFBJMEEKBJ2F7XXNHR',
      name: 'Юсуф Р. А.',
      phone: '+7 *** *** 39 68',
      ticket: '001-586-30',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE2XC8WB419B8YFRWDBZVDCY',
      name: 'Иван С. Ф.',
      phone: '+7 *** *** 33 17',
      ticket: '007-381-55',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDPRSYYZ9TA9CYC4C214KVS2',
      name: 'Владимир А. П.',
      phone: '+7 *** *** 70 36',
      ticket: '003-282-94',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEK4FCABGRJP485BWFD63B98',
      name: 'Алексей В. А.',
      phone: '+7 *** *** 80 45',
      ticket: '005-119-97',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDPPQ0JV94MPVAYJGZ01Y7GH',
      name: 'Олеся А. М.',
      phone: '+7 *** *** 27 14',
      ticket: '004-115-71',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEKG4G9QGE44KDS32B9EPKSH',
      name: 'Денис Ю. П.',
      phone: '+7 *** *** 61 05',
      ticket: '005-233-04',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEAR32A60V56ZYZS1GT7GPMV',
      name: 'Анна В. Д.',
      phone: '+7 *** *** 21 96',
      ticket: '008-431-05',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDN888E8CNGM8WZC0PAJGJZH',
      name: 'Сергей С. П.',
      phone: '+7 *** *** 56 79',
      ticket: '000-125-50',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE1F7W3HC8MC8M1FCWSKVKY7',
      name: 'Ирина М. Л.',
      phone: '+7 *** *** 22 36',
      ticket: '006-381-19',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE58C2HRS6VESMWVBHPPA1S5',
      name: 'Екатерина А. Р.',
      phone: '+7 *** *** 60 38',
      ticket: '011-011-81',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JESHRC7CP5AK7ZBVV2PN5AS1',
      name: 'Андрей С. Х.',
      phone: '+7 *** *** 89 06',
      ticket: '012-886-14',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDQD55Y41JPJ4EDPDNTR74YD',
      name: 'Александр А. З.',
      phone: '+7 *** *** 52 11',
      ticket: '002-641-61',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JF7SC5XQTSJDA6FFHZPDSWZR',
      name: 'Алексей М. П.',
      phone: '+7 *** *** 89 27',
      ticket: '010-875-08',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDN6RQ6GSZWB0MV0F90CHRK1',
      name: 'Давид С. Р.',
      phone: '+7 *** *** 40 15',
      ticket: '000-390-74',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDQK37PG105P0365Y3JN2GF8',
      name: 'Вячеслав В. Д.',
      phone: '+7 *** *** 72 35',
      ticket: '002-639-30',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDN94JVX1MGX2GQD1QQZBYH4',
      name: 'Дмитрий М. Ч.',
      phone: '+7 *** *** 34 40',
      ticket: '001-138-17',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE1DVDFQ1K7X8Z8RM3HWX1TN',
      name: 'Ильшат И. С.',
      phone: '+7 *** *** 12 90',
      ticket: '008-930-81',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDSAG8WPESK29GVMCTB5VDFH',
      name: 'Григорий М. Т.',
      phone: '+7 *** *** 91 19',
      ticket: '002-155-04',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEAJS4KNC0BRMDAK14PQBDE9',
      name: 'Алексей А. З.',
      phone: '+7 *** *** 84 69',
      ticket: '006-644-78',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDNW3VQCJYNDHEQGS4MVHGC9',
      name: 'Дмитрий А. К.',
      phone: '+7 *** *** 94 31',
      ticket: '003-396-48',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDPJ7VKAHCDRR1NXQJ5GVWKM',
      name: 'Александр М. Г.',
      phone: '+7 *** *** 31 44',
      ticket: '001-076-70',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE4360A41GA9RSGKTED7XYPD',
      name: 'Владислав Н. Б.',
      phone: '+7 *** *** 69 31',
      ticket: '004-907-20',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDS8JQ72TQJH3333NC5ET69T',
      name: 'Александр Ю. А.',
      phone: '+7 *** *** 42 00',
      ticket: '001-382-23',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEZ6S1XMVEQKQJTYAWS36PJ0',
      name: 'Елена Ю. И.',
      phone: '+7 *** *** 54 74',
      ticket: '009-084-66',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEB7T5EEDF2RRYRWG9F9JDEV',
      name: 'Владимир И. К.',
      phone: '+7 *** *** 53 06',
      ticket: '005-378-41',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDMK8Q306ZH8WWPRCV9ZTHC5',
      name: 'Александр Н. М.',
      phone: '+7 *** *** 12 23',
      ticket: '000-244-41',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDNX9KE79QE7MSAB78VN2YYT',
      name: 'Сергей А. К.',
      phone: '+7 *** *** 28 84',
      ticket: '011-295-50',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEADY23T00JSMGF6E36NQW4J',
      name: 'Екатерина П. Р.',
      phone: '+7 *** *** 61 93',
      ticket: '002-394-82',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDQKXS7T0THK8R4EZ8GX45D2',
      name: 'Ольга А. И.',
      phone: '+7 *** *** 18 26',
      ticket: '006-415-29',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDNXMG48TAYVP35FSNEK071K',
      name: 'Виктория В. Ш.',
      phone: '+7 *** *** 25 56',
      ticket: '008-020-29',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDN50SJWQ5T5616NZ1PXNGR6',
      name: 'Матвей Д. Н.',
      phone: '+7 *** *** 02 16',
      ticket: '009-374-57',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE5MK7917J1KEM3NBED5ASG5',
      name: 'Игорь Е. Д.',
      phone: '+7 *** *** 14 63',
      ticket: '011-695-30',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDP3F8NCHBZ9B5RM41MEXSKR',
      name: 'Богдан В. Б.',
      phone: '+7 *** *** 74 00',
      ticket: '000-502-74',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDY2QGX7600GSVE06EXYEP44',
      name: 'Лариса Н. З.',
      phone: '+7 *** *** 53 70',
      ticket: '002-054-01',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE5M7Z23FGVC5AWC548VC637',
      name: 'Юлия Е. К.',
      phone: '+7 *** *** 79 89',
      ticket: '005-079-81',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDQG8AZDB0N0MEBSSJQQ802F',
      name: 'Александр В. Я.',
      phone: '+7 *** *** 42 49',
      ticket: '004-155-52',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDNQQR7HQP2T6RWHXEQW2RT0',
      name: 'Александра В. С.',
      phone: '+7 *** *** 42 22',
      ticket: '010-444-77',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEBPAEEJ186HN6B0GT5MJWR9',
      name: 'Рустам Р. Х.',
      phone: '+7 *** *** 87 56',
      ticket: '006-726-98',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JEG6GV28CTE1PFVW6173PHAG',
      name: 'Максим А. Т.',
      phone: '+7 *** *** 03 95',
      ticket: '010-921-16',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JE858D6PT82MQTZZ9KYMS0QX',
      name: 'Ольга Л. Д.',
      phone: '+7 *** *** 87 53',
      ticket: '008-173-74',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDPQ63MZHDECH3YRC2KCPF38',
      name: 'Владимир С. А.',
      phone: '+7 *** *** 92 79',
      ticket: '011-522-22',
    },
    {
      type: ResultGiftType.TShop,
      id: '01JDNN6XMCA8XYCACH783KNWQT',
      name: 'Андрей П. С.',
      phone: '+7 *** *** 88 22',
      ticket: '002-630-89',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JFASCSKVE2QQSVA0SKHDTZT9',
      name: 'Марина В. С.',
      phone: '+7 *** *** 16 01',
      ticket: '012-523-29',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDST83H3P87BZYX3KDRQ4BA0',
      name: 'Лейсан М. Х.',
      phone: '+7 *** *** 58 84',
      ticket: '002-746-71',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JFK2Z6NKQS0MZPJZVZ4MAA2K',
      name: 'Артём А. О.',
      phone: '+7 *** *** 49 14',
      ticket: '010-770-06',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDNJMB3Q9WTCEZVNGZD749W4',
      name: 'Александра Е. О.',
      phone: '+7 *** *** 31 30',
      ticket: '003-150-56',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE5XQE157GT2A03BYMDCQ7TA',
      name: 'Александр А. Е.',
      phone: '+7 *** *** 63 85',
      ticket: '007-011-60',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDSDXZWA85AJ2JYMPS3TKJW2',
      name: 'Князь М. С.',
      phone: '+7 *** *** 69 01',
      ticket: '010-849-01',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDN7R7SYGT8XW81EBA6TQBAR',
      name: 'Гузель А. Х.',
      phone: '+7 *** *** 95 56',
      ticket: '011-281-80',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPSJAQH8AJ264HPZAQ53B0S',
      name: 'Александра Г. Т.',
      phone: '+7 *** *** 19 78',
      ticket: '006-701-56',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JF789P8ADCYJET1WYDK7EGPF',
      name: 'Александр С. М.',
      phone: '+7 *** *** 20 44',
      ticket: '013-027-11',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEDB7A8KHAGYT9C0DNABAX1W',
      name: 'Раиль Ш. Т.',
      phone: '+7 *** *** 55 20',
      ticket: '006-908-25',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE1Q1RJY03QTJ653HASYCD34',
      name: 'Юлия О. Г.',
      phone: '+7 *** *** 51 03',
      ticket: '001-972-93',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPW7WS0W6HT63NDFDFJ6RA3',
      name: 'Вадим А. З.',
      phone: '+7 *** *** 18 86',
      ticket: '005-509-17',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE68P4NEM9Y1WSJVMV3VSBBV',
      name: 'Камила П. П.',
      phone: '+7 *** *** 33 74',
      ticket: '006-644-28',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JFAXKRDJBVFR4M9Z1TZJZYCH',
      name: 'Ольга В. Т.',
      phone: '+7 *** *** 91 04',
      ticket: '011-539-50',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDKY0AHC2WTZEWJPF2RSTVPD',
      name: 'Анастасия В. А.',
      phone: '+7 *** *** 31 61',
      ticket: '006-365-73',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE9P9ZTKBK0W9WD03KGSVMYX',
      name: 'Лариса Н. Е.',
      phone: '+7 *** *** 78 77',
      ticket: '007-073-04',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEQWG3FZFVKBRMS45WE83BJX',
      name: 'София Р. Н.',
      phone: '+7 *** *** 15 22',
      ticket: '010-518-01',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE638SJECBKMC3AQEMF1X8N3',
      name: 'Екатерина В. К.',
      phone: '+7 *** *** 56 43',
      ticket: '006-856-65',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDS3KD2DGCK21SH0Q34C4C6D',
      name: 'Альберт Г. А.',
      phone: '+7 *** *** 33 32',
      ticket: '001-348-47',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JETRTRW9VNBWEZK9ANJVR56P',
      name: 'Олег А. С.',
      phone: '+7 *** *** 10 97',
      ticket: '008-841-06',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JENC007DBG10GXV42SFXVBN1',
      name: 'Александр В. С.',
      phone: '+7 *** *** 68 67',
      ticket: '008-438-38',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDP60172NWVPGBQNK8G22AQE',
      name: 'Ринат Р. Г.',
      phone: '+7 *** *** 11 91',
      ticket: '000-118-19',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDSQH3Z88SP7FZCEGZQSA6D7',
      name: 'Дамир З. Р.',
      phone: '+7 *** *** 03 13',
      ticket: '001-218-03',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDP88PJ2K8EFDJH5W38NTFTS',
      name: 'Елизавета С. К.',
      phone: '+7 *** *** 66 84',
      ticket: '006-053-58',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPEVF77SWDHMR2MYFXW4J27',
      name: 'Максим П. Д.',
      phone: '+7 *** *** 44 72',
      ticket: '000-672-50',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPD1EZ3ZQ454V36MW6ZSH0H',
      name: 'Фарит Ф. Г.',
      phone: '+7 *** *** 98 69',
      ticket: '000-517-61',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDNJXZTEG0CTGJNQ0XDBTM53',
      name: 'Алексей С. Ц.',
      phone: '+7 *** *** 23 00',
      ticket: '000-537-00',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE7XYVHX44WW66C4HRA735B6',
      name: 'Елена Г. Щ.',
      phone: '+7 *** *** 01 25',
      ticket: '008-167-39',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE0NWNC9ZS1AFA2385731JBH',
      name: 'Екатерина С. К.',
      phone: '+7 *** *** 09 33',
      ticket: '001-970-67',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDN4V7JRGP5TSACJHW9A76K7',
      name: 'Надежда А. К.',
      phone: '+7 *** *** 08 81',
      ticket: '002-965-48',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEX9WBNFWGHZQBR5WS5R6D7H',
      name: 'Алексей В. Б.',
      phone: '+7 *** *** 65 47',
      ticket: '011-327-25',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEAM06SERRKZEVP3Q48WJ33A',
      name: 'Андрей А. Л.',
      phone: '+7 *** *** 01 88',
      ticket: '006-066-28',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPN5E1BB61MB7DWSG76QM30',
      name: 'Павел Э. С.',
      phone: '+7 *** *** 60 96',
      ticket: '001-095-28',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE8TZ8QX4QYE8Q7NWY2C73DF',
      name: 'Олеся С. К.',
      phone: '+7 *** *** 50 39',
      ticket: '004-990-44',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDQH1GMXHWC73SDK69KMVYV7',
      name: 'Юлия В. З.',
      phone: '+7 *** *** 65 25',
      ticket: '003-304-97',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPFFN9F3DG97A1Y7RDRSFH5',
      name: 'Инна В. М.',
      phone: '+7 *** *** 40 09',
      ticket: '006-624-40',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEGKV544F35NAK1X6D5KY48X',
      name: 'Андрей В. К.',
      phone: '+7 *** *** 54 02',
      ticket: '008-443-46',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JER6XHS942QW8BBG3ZT7BQJK',
      name: 'Елена П. Е.',
      phone: '+7 *** *** 85 91',
      ticket: '008-701-03',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEBD7B9QWM8A6PZ2BMWX4RNN',
      name: 'Андрей Л. Ш.',
      phone: '+7 *** *** 80 33',
      ticket: '004-704-85',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDQGFPF09ZJDZCPEQGYVBJ52',
      name: 'Ренат Р. М.',
      phone: '+7 *** *** 75 77',
      ticket: '001-274-06',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDRPFJN21MTW9AEXF10Z5XMG',
      name: 'Инна М. Х.',
      phone: '+7 *** *** 89 43',
      ticket: '001-104-00',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDRXJXR6XKQZ0HR5TH33TW1J',
      name: 'Михаил П. Н.',
      phone: '+7 *** *** 81 19',
      ticket: '000-973-41',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE8M13VWR2ZHY5ZS9RXZWAMS',
      name: 'Екатерина Ю. К.',
      phone: '+7 *** *** 41 25',
      ticket: '002-925-55',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDQTJEJJH7ZVSJTR205VTX4V',
      name: 'Артем Д. С.',
      phone: '+7 *** *** 99 69',
      ticket: '005-921-16',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDP5DNXEAH5WJMP08WREFBQ7',
      name: 'Владимир С. А.',
      phone: '+7 *** *** 71 00',
      ticket: '009-402-83',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPQVPSS1751C3TEZEERW0K0',
      name: 'Артем Э. Н.',
      phone: '+7 *** *** 54 42',
      ticket: '002-822-11',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEC1NZWYZG9K8RWWRKJ8CCTJ',
      name: 'Руслан А. Ж.',
      phone: '+7 *** *** 63 30',
      ticket: '004-865-93',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPER8SMGPTPKFS6KX7Y5ND2',
      name: 'Оксана Н. С.',
      phone: '+7 *** *** 31 26',
      ticket: '000-939-99',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE8R6S9M8RE29133VK7VQ63T',
      name: 'Дмитрий С. Н.',
      phone: '+7 *** *** 38 08',
      ticket: '006-075-33',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JFF78QBYVMR713PWER49E44C',
      name: 'Илья С. Б.',
      phone: '+7 *** *** 12 56',
      ticket: '012-920-93',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDNEJBFWGACSHWSD33A6B3RC',
      name: 'Светлана В. Б.',
      phone: '+7 *** *** 28 61',
      ticket: '000-988-95',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEP389GFR1SQKCVHZXAN35WQ',
      name: 'Александра В. А.',
      phone: '+7 *** *** 63 56',
      ticket: '010-493-12',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE6JN3AHVWT74AH80VC154AX',
      name: 'Алексей А. Б.',
      phone: '+7 *** *** 02 70',
      ticket: '004-866-05',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE9AWZ56YJ73WKE44JZPQBGN',
      name: 'Даниил Н. П.',
      phone: '+7 *** *** 94 05',
      ticket: '004-050-00',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDPTD7SHBB0J3BMGRPY9R00F',
      name: 'Максим А. Ж.',
      phone: '+7 *** *** 80 88',
      ticket: '008-196-00',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE9KSY2EVHZV29GJT40F3BTN',
      name: 'Наталья А. В.',
      phone: '+7 *** *** 75 54',
      ticket: '006-847-86',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE15YVWTW14X0B0E4EBQ84A3',
      name: 'Артём С. В.',
      phone: '+7 *** *** 01 24',
      ticket: '002-012-17',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JDS9D9B8E34K1ZE614NCJTE2',
      name: 'Александр В. Р.',
      phone: '+7 *** *** 03 25',
      ticket: '008-231-60',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEZA6FNCS61C4Q2G189C7NRH',
      name: 'Владимир В. О.',
      phone: '+7 *** *** 18 37',
      ticket: '011-962-24',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JFD58S4Y2YY0HYCEFY231E9B',
      name: 'Алиса Ф. Р.',
      phone: '+7 *** *** 30 45',
      ticket: '012-432-67',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEB2HKM2MY1PM06FKBPMA1A0',
      name: 'Люция Т. Г.',
      phone: '+7 *** *** 15 21',
      ticket: '006-811-27',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JE92KHHJ3HHMBFPRPSQEHRBQ',
      name: 'Никита В. А.',
      phone: '+7 *** *** 88 37',
      ticket: '005-022-85',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEKJ67XFAKHV85AFTMVY28F6',
      name: 'Александр В. О.',
      phone: '+7 *** *** 24 34',
      ticket: '010-396-42',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JETPCBDHB5TCRCP9QPFAMTV8',
      name: 'Ксения М. П.',
      phone: '+7 *** *** 76 31',
      ticket: '010-481-61',
    },
    {
      type: ResultGiftType.Stocks,
      id: '01JEKBZ2X8MMAJA7Q6MSYZMQ40',
      name: 'Андрей В. Т.',
      phone: '+7 *** *** 13 28',
      ticket: '005-429-92',
    },
  ] as Winner[],
};
